/* eslint-disable */
import { useDispatch, useSelector } from 'react-redux';
import { sentenceCase } from 'change-case';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import axios from 'axios';

// React Icons
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import ClearIcon from '@mui/icons-material/Clear';
import NoteIcon from '@mui/icons-material/Note';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import CreditCardOffIcon from '@mui/icons-material/CreditCardOff';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { NotificationAdd } from '@mui/icons-material';
import PaidIcon from '@mui/icons-material/Paid';
import HistoryIcon from '@mui/icons-material/History';
import HomeIcon from '@mui/icons-material/Home';
import EmailIcon from '@mui/icons-material/Email';
import { HighlightOff } from '@mui/icons-material';
import { ModeEdit } from '@mui/icons-material';
import UndoSharpIcon from '@mui/icons-material/UndoSharp';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { MdEditSquare } from 'react-icons/md';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteIcon from '@mui/icons-material/Delete';
import VerifiedIcon from '@mui/icons-material/Verified';
import WarningIcon from '@mui/icons-material/Warning';

// material
import { Typography, InputLabel, FormControl, TableContainer, TablePagination, IconButton } from '@mui/material';
import { Snackbar, MenuItem, TableRow, TableBody, TableCell, TableHead, Container } from '@mui/material';
import { Box, Card, Table, Stack, Modal, Alert, Select, Button, Tooltip, Checkbox, TextField } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import TabList from '@mui/lab/TabList';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { FaCreditCard } from 'react-icons/fa6';
import { MdCreditScore } from 'react-icons/md';

// Components
import downloadSalaryDetailsAsPdf, { convertHouseworkType, invoiceDropOptions } from '../../../utils/commonFunc';
import SendInvoiceEmail from './InvoicesModal/SendInvoiceEmail';
import BookEditInvoice from './InvoicesModal/BookEditInvoice';
import { ListHead, ListToolbar } from '../../../sections/@dashboard/table';
import TooltipWithCopy from '../../../components/TooltipWithCopy';
import SearchNotFound from '../../../components/SearchNotFound';
import Page from '../../../components/Page';
import Label from '../../../components/Label';
import Scrollbar from '../../../components/Scrollbar';
import ErrosAlert from '../customers/ErrosAlert';
import Loader from '../../../components/Loader';
import { costPerDayArticle, costPerMonthArticle, costAgreementArticle, costPerWeekArticle } from '../Article';
import { HourlyWages, otherCost, ExpenditureAccordingToTheAttachedPDF } from '../Article';
import { formatDate, formatDate2, getModalBoxStyle } from '../../../utils/commonFunc';
import '../../../layouts/dashboard/index/index.css';
import ReminderInvoiceDataTable from '../../../components/reminder-invoice/ReminderInvoiceDataTable';
import CreditNoteModal from './InvoicesModal/CreditNoteModal';
import { fetchGlobalData } from 'src/redux/globalData/globalDataSlice';
import { getInvoiceData } from '../../../redux/auth/authSlice';
import { invoiceCreatedUserDetails } from 'src/redux/globalData/userSlice';
import { 
  setSearchQuery as setInvoiceSearchQuery,
  setSearchDropValue as setInvoiceSearchDropValue, 
  setSelectedTabValue as setInvoiceSelectedTabValue,
  setNavigatedAway,
  setPreserveSearch,
  resetInvoiceSearch 
} from 'src/redux/globalData/invoiceSearchSlice';
import { ARTICLE_NUMBERS, INVOICE_STATUS } from 'src/utils/constants';
import { useSSNVerification } from '../../../components/SSNVerification';
import { fr } from 'date-fns/locale';
import { RequestStatus } from '../../../enums/RequestStatusEnum';
import { useParams } from 'react-router-dom';
import Iconify from '../../../components/Iconify';
import EmailHistory from './InvoicesModal/EmailHistory';
import { set } from 'lodash'; 
// ----------------------------------------------------------------------



const WORKING_HOURS_TABLE_HEAD = [
  {
    id: 'workingDate',
    label: 'Date',
    alignRight: false,
    flex: 1,
    padding: '6px 16px',
  },
  {
    id: 'articleName',
    label: 'Article Name',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'IsArticleShownInInvoice',
    label: 'Is Shown',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'vat',
    label: 'VAT%',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'Bookkeeping',
    label: 'Account',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'number',
    label: 'Unit Number',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'amountPerUnit',
    label: 'Amount per unit',
    alignRight: false,
    padding: '6px 16px',
  },

  { id: 'totalAmount', label: 'SEK', alignRight: false, padding: '6px 16px' },

  {
    id: 'grossAmount',
    label: 'Gross Salary',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'expressFee',
    label: 'Express Fee',
    alignRight: false,
    padding: '6px 16px',
  },
  { id: 'distance', label: 'Distance', alignRight: false, padding: '6px 16px' },
  { id: 'carRegistrationNo', label: 'Car Registration No.', alignRight: false, padding: '6px 16px' },
  { id: 'tripStartedPlace', label: 'Trip Started Place', alignRight: false, padding: '6px 16px' },
  { id: 'tripStartedDate', label: 'Trip Started Date', alignRight: false, padding: '6px 16px' },
  { id: 'tripEndedDate', label: 'Trip Ended Date', alignRight: false, padding: '6px 16px' },
  { id: 'reasonForTrip', label: 'Reason For Trip', alignRight: false, padding: '6px 16px' },
  { id: 'country', label: 'Country', alignRight: false, padding: '6px 16px' },
  { id: 'destination', label: 'Destination', alignRight: false, padding: '6px 16px' },
];

const INVOICE_PDF_TABLE_HEAD = [
  {
    id: 'fileName',
    label: 'File Name',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'isShown',
    label: 'Is Shown',
    alignRight: false,
    padding: '6px 16px',
  },
  {
    id: 'action',
    label: 'Action',
    alignRight: false,
    padding: '6px 16px',
  },
];

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query, originalArray) {
  let filteredArray = array;
  
  // Apply search filter if query is provided
  if (query) {
    filteredArray = array?.filter((item) => {
      // Search in multiple fields
      const searchFields = [
        item.invoiceNumber?.toString(),
        item.customerName?.toLowerCase(),
        item.userName?.toLowerCase(),
        item.createdBy?.toString(),
        item.ocrNo?.toString(),
        item.fortnoxInvoiceNumber?.toString(),
        item.creditOriginInvoiceNumber?.toString()
      ];
      
      return searchFields.some(field => 
        field && field.includes(query.toLowerCase())
      );
    });
  }
  
  // Apply sorting
  const stabilizedThis = filteredArray?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  return stabilizedThis?.map((el) => el[0]);
}

export default function Invoices() {
  // Utility function to format numbers with space as thousands separator
  const formatNumber = (value) => {
    if (!value && value !== 0) return '0.00';
    return Number(value.toFixed(2)).toLocaleString('en-US', { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).replace(/,/g, ' ');
  };

  // Initialize SSN Verification hook
  const { handleSSNVerification: ssnVerificationAPI, loading: ssnLoading } = useSSNVerification();

  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('desc');
  const [invoices, setInvoices] = useState([]);
  const [selected, setSelected] = useState([]);
  const [invoiceSelected, setInvoiceSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  // Redux selectors for persistent search state
  const invoiceSearchState = useSelector((state) => state.invoiceSearch);
  const persistedSearchDropValue = invoiceSearchState.searchDropValue;
  const persistedSelectedTabValue = invoiceSearchState.selectedTabValue;
  const persistedSearchQuery = invoiceSearchState.searchQuery;
  const navigatedAway = invoiceSearchState.navigatedAway;
  const preserveSearch = invoiceSearchState.preserveSearch;
  
  // Use persisted values, fallback to defaults if undefined
  const searchQuery = persistedSearchQuery || '';
  const searchDropValue = persistedSearchDropValue;
  const selectedTabValue = persistedSelectedTabValue || '1';
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [selectedRow, setSelectedRow] = useState({});
  const [selectedRowInvoiceNumber, setSelectedRowInvoiceNumber] = useState(0);
  const [userPdf, setUserPdf] = useState([]);
  const [alertMessage, setAlertMessage] = useState('');
  const [orderBy, setOrderBy] = useState('createdDate');
  const [freelancerName, setFreelancerName] = useState('');
  const [alertStatus, setAlertStatus] = useState('success');
  const [getEditInvoiceData, setGetEditInvoiceData] = useState({});
  const [isSnackBarOpen, setIsSnackBarOpen] = useState(false);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  // selectedTabValue is now defined above from Redux state
  const [autoHideDuration, setAutoHideDuration] = useState(3000);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [originalInvoice, setoriginalInvoice] = useState([]);
  const [hideCheckboxColumn, setHideCheckboxColumn] = useState(true);
  const [remindersRow, setRemindersRow] = useState(false);
  const [selectedAddNewRow, setSelectedAddNewRow] = useState({});
  const [adminInvoiceReminderCheck, setAdminInvoiceReminderCheck] = useState(false);
  const [selectedFreelancer, setSelectedFreelancer] = useState(0);
  const [invoiceDetails, setInvoiceDetails] = useState(null); // New state to store invoice details
  const [tooltipTitle, setTooltipTitle] = useState('');
  const [defaultAllTabForUser, setDefaultAllTabForUser] = useState(true);
  const [additionalInvoiceCharges, setAdditionalInvoiceCharges] = useState([]);
  const [pdfLang, setPdfLang] = useState("en-us");
  const [isOpenModal, setIsOpenModal] = useState({
    open: false,
    index: null,
  });

  const [activateModal, setActivateModal] = useState({
    id: null,
    show: false,
  });

  const [toggleIsActive, settoggleIsActive] = useState({
    id: null,
    invoiceNumber: null,
    show: false,
  });

  const [createAccountModal, setCreateAccountModal] = useState({
    id: null,
    invoiceNumber: null,
    show: false,
    type: '',
    dueDate: '',
  });

  const [expressPaymenttModal, setExpressPaymentModal] = useState({
    id: null,
    show: false,
    type: false,
    invoiceNumber: null,
  });
  
  const [sendEmailModal, setSendEmailModal] = useState({
    open: false,
    selectedRow: null,
  });
  

  const [IstogglePaidUnpaid, setIstogglePaidUnpaid] = useState({
    id: null,
    show: false,
    type: '',
    invoiceNumber: null,
  });
  const [hasScrolledToTop, setHasScrolledToTop] = useState(false);
  const [isChangeStatus, setisChangeStatus] = useState({
    id: null,
    show: false,
    type: '',
    invoiceNumber: null,
  });

  const [isAllSelected, setAllSelected] = useState(false);
  const [toggleNote, setToggleNote] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(false);
  const [selectedInvoiceNumber, setSelectedInvoiceNumber] = useState(false);
  const [notesContent, setNotesContent] = useState('');
  const [isNotesContentEmpty, setIsNotesContentEmpty] = useState(false);
  const [selectedNotes, setSelectedNotes] = useState([]);
  const [deleteNotesModal, setDeleteNotesModal] = useState({ show: false });
  const [commentList, setcommentList] = useState([]);
  // searchDropValue is now defined above from Redux state
  const [showSyncModal, setshowSyncModal] = useState(false);
  const [isError, setisError] = useState(false);
  const [messages, setMessages] = useState({
    customerUpdatedOnFortnox: null,
    customerUpdatedOnFortnoxError: null,
    customeraddedOnFortnox: null,
    customeraddedOnFortnoxError: null,
    invoiceCanceledOnFortnox: null,
    invoiceCanceledOnFortnoxError: null,
    invoiceFileuploadedOnFortnox: null,
    invoiceFileuploadedOnFortnoxError: null,
    invoiceTaxReductioncreatedOnFortnox: null,
    invoiceTaxReductioncreatedOnFortnoxError: null,
    invoiceUpdatedOnFortnox: null,
    invoiceUpdatedOnFortnoxError: null,
    invoiceaddedOnFortnox: null,
    invoiceaddedOnFortnoxError: null,
  });

  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userId } = useParams();
  const userIdFromParams = userId;

  useEffect(() => {
    // Check if user is returning from external navigation (like edit pages)
    if (navigatedAway === true) {
      // Clean up the navigation flags
      dispatch(setNavigatedAway(false));
      if (preserveSearch) {
        dispatch(setPreserveSearch(false));
      }
    }
    
    fetchInvoices();
    
    // Only set default tab if no persisted tab value exists
    if (!persistedSelectedTabValue) {
      dispatch(setInvoiceSelectedTabValue('1'));
    }
  }, [userId, search]);

  // Additional check for when user returns to the page (e.g., browser back button)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        if (navigatedAway === true && !preserveSearch) {
          dispatch(resetInvoiceSearch({ force: true }));
          // Refetch data to ensure consistency
          fetchInvoices();
        } else if (navigatedAway === true) {
          // Just clean up navigation flags if preserving search
          dispatch(setNavigatedAway(false));
          dispatch(setPreserveSearch(false));
        }
      }
    };

    const handleFocus = () => {
      if (navigatedAway === true && !preserveSearch) {
        dispatch(resetInvoiceSearch({ force: true }));
        // Refetch data to ensure consistency
        fetchInvoices();
      } else if (navigatedAway === true) {
        // Just clean up navigation flags if preserving search
        dispatch(setNavigatedAway(false));
        dispatch(setPreserveSearch(false));
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
    };
  }, [dispatch]);

  // Clear search state on page refresh only
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      // Clear on page refresh/close
      dispatch(resetInvoiceSearch());
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [dispatch]);

  // Apply search filter when component loads with persisted search values
  useEffect(() => {
    if (originalInvoice.length > 0) {
      if (searchQuery) {
        const filteredRows = applySortFilter(
          originalInvoice,
          getComparator(order, orderBy),
          searchQuery,
          originalInvoice
        );
        setFilteredInvoices(filteredRows);
      } else {
        // If no search query, show all invoices
        setFilteredInvoices(originalInvoice);
      }
    }
  }, [searchQuery, originalInvoice, order, orderBy]);

  const TABLE_HEAD = [
    { id: 'invoiceNumber', label: 'Invoice No', alignRight: false },
    { id: 'fortnoxInvoiceNumber', label: 'Fortnox Invoice No', alignRight: false },
    { id: 'creditOriginInvoiceNumber', label: 'Original Invoice No', alignRight: false },
    { id: 'ocrNo', label: 'OCR No', alignRight: false },
    { id: 'invoiceType', label: 'Invoice Type', alignRight: false },
    { id: 'customerName', label: 'Customer', alignRight: false },
    { id: 'customerId', label: 'Customer Id', alignRight: false },
    { id: 'invoiceVersion', label: 'Invoice Version', alignRight: false },
    { id: 'createdBy', label: 'User Id', alignRight: false },
    { id: 'userName', label: 'Username', alignRight: false },
    { id: 'createdDate', label: 'Created Date', alignRight: false },
    { id: 'dueDate', label: 'Due Date', alignRight: false },
    { id: 'amountIncVat', label: 'Amount (Inc. VAT)', alignRight: false },
    { id: 'invoiceStatus', label: 'Invoice Status', alignRight: false },
    { id: 'invoiceSalaryStatus', label: 'Salary Status', alignRight: false },
    { id: 'expressPayout', label: 'Express Payment', alignRight: false },
    { id: 'Salary', label: 'Salary', alignRight: false },
    { id: 'isActive', label: 'Actions', alignRight: false },
  ].filter((column) => {
    if (selectedTabValue === '6') {
      return (
        column.id !== 'invoiceStatus' &&
        column.id !== 'invoiceSalaryStatus' &&
        column.id !== 'expressPayout'
      );
    }
    if (selectedTabValue === '1' || selectedTabValue === '2' || selectedTabValue === '3' || selectedTabValue === '4' || selectedTabValue === '5' || selectedTabValue === '7' || selectedTabValue === '8' || selectedTabValue === '9' || selectedTabValue === '10') {
      return (
        column.id !== 'fortnoxInvoiceNumber' && column.id !== 'creditOriginInvoiceNumber' &&
        column.id !== 'customerId'
      );
    }
    if (selectedTabValue !== '4') {
      return true;
    }
    return column.id !== 'invoiceStatus' && column.id !== 'invoiceSalaryStatus';
  });

  const articlesNumber = {
    HourlyWages: '92',
    otherCost: '93',
    ExpenditureAccordingToTheAttachedPDF: '2',
    costPerDay: '94',
    costPerWeek: '95',
    costPerMonth: '96',
    costAgreement: '97',
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      fetchInvoices();
    }, 600);
    return () => clearTimeout(timeoutId);
  }, [page, rowsPerPage, selectedTabValue, searchQuery, searchDropValue]);

  const addNewAdditionCharges = (isDeduct) => {
    const hasPendingRow = additionalInvoiceCharges.some((charge) => charge.id === 0);

    if (hasPendingRow) {
      return;
    }

    setAdditionalInvoiceCharges([
      ...additionalInvoiceCharges,
      { id: 0, reminderText: '', feeValue: '', editing: true, showCheck: true, isNew: true, isDeduct: isDeduct },
    ]);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editCreditModalDetails, setEditCreditModalDetails] = useState({}); // Message for the modal

  const handleViewPdf = async (id, lang) => {
    try {
      setLoading(true);
      const user = JSON.parse(localStorage.getItem('admin'));
      let token = user?.token || '';
      const response = await axios.get(`/admin/invoice/invoice-pdf?invoiceNumber=${id}&locale=${lang}`, {
        responseType: 'blob',
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
        }
      });
     if (response.status !== 200){
      setLoading(false);
       throw new Error('Failed to fetch PDF');
     }
      const url = window.URL.createObjectURL(response.data);
      window.open(url, '_blank');
      const invoiceNumber = selectedRow?.invoiceNumber || id;
      const link = document.createElement('a');
      link.href = url;
     link.setAttribute('download', `${invoiceNumber}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('PDF fetch error:', error);
    }
  };

  const handleOpenSendEmailModal = () => {
    setSendEmailModal({
      open: true,
      selectedRow: selectedRow,
    });
    // Close salary detail modal when opening email modal
    setIsOpenModal((prevState) => ({ ...prevState, open: false }));
  };

  const handleCloseSendEmailModal = () => {
    setSendEmailModal({
      open: false,
      selectedRow: null,
    });
  };

  const handleOpenEditModal = async (invoiceNumber) => {
    try {
      setLoading(true);
      const response = await axios.get(`/AdminInvoiceEdit/${invoiceNumber}?requestType=${RequestStatus.General}`);
      const data = response.data;
      setEditCreditModalDetails(data);
      if (data?.isAnyResponseOnEditCreditInvoice === true || data?.invoiceEditItems.length === 0) {
        setIsEditModalOpen(true);
        return;
      }
      const URL = `/admin/invoice/get-invoice/${invoiceNumber}`;
      const result = await axios.get(URL);
      setGetEditInvoiceData(result.data.response);

      if (result?.status === 200) {
        const fetchInvoices = result?.data?.response;
        const {
          vat,
          amount,
          isFixed,
          customer,
          showDates,
          invoiceNumber,
          description,
          invoiceFreelancer,
          workingHours,
          file,
        } = fetchInvoices;

        const filteredWorkingHours = workingHours?.filter((item) => {
          return (
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
          );
        });

        const freelancer =
          invoiceFreelancer?.length > 0
            ? invoiceFreelancer?.map((item) => ({
              amount: item.amount,
              userId: item.userId,
              holidaySavings: item.holidaySavings,
              holidaySavingsFee: item.holidaySavingsFee,
              pension: item.pension,
              pensionAmount: item.pensionAmount,
              signUpUser: item.freelancerDetails,
            }))
            : [];

        const invoiceHours = [];

        if (freelancer && freelancer.length !== 0) {
          freelancer?.forEach((freelancers) => {
            let array = [];
            filteredWorkingHours?.forEach((item) => {
              const { amountPerUnit, number, articleNumber, workingDate, userId, houseworkType, dateId } = item;

              // Check if userId is present in freelancers.userId array
              if (userId === freelancers?.userId) {
                array = [
                  {
                    ...array[0],
                    [dateId ? dateId : workingDate.split('T')[0]]: {
                      units: number,
                      amount: amountPerUnit,
                      houseworkType: {
                        value: houseworkType,
                        name: convertHouseworkType(houseworkType),
                      },
                      article:
                        articleNumber === articlesNumber.HourlyWages
                          ? HourlyWages
                          : articleNumber === articlesNumber.otherCost
                            ? otherCost
                            : articleNumber === articlesNumber.costPerDay
                              ? costPerDayArticle
                              : articleNumber === articlesNumber.costPerWeek
                                ? costPerWeekArticle
                                : articleNumber === articlesNumber.costPerMonth
                                  ? costPerMonthArticle
                                  : articleNumber === articlesNumber.costAgreement
                                    ? costAgreementArticle
                                    : articleNumber === articlesNumber.ExpenditureAccordingToTheAttachedPDF
                                      ? ExpenditureAccordingToTheAttachedPDF
                                      : '',
                    },
                  },
                ];
              }
            });
            invoiceHours.push(...array);
          });
        } else {
          let array = [];
          filteredWorkingHours?.forEach((item) => {
            const { amountPerUnit, number, articleNumber, workingDate, houseworkType, dateId } = item;
            array = [
              {
                ...array[0],
                [dateId ? dateId : workingDate.split('T')[0]]: {
                  units: number,
                  amount: amountPerUnit,
                  houseworkType: {
                    value: houseworkType,
                    name: convertHouseworkType(houseworkType),
                  },
                  article:
                    articleNumber === articlesNumber.HourlyWages
                      ? HourlyWages
                      : articleNumber === articlesNumber.otherCost
                        ? otherCost
                        : articleNumber === articlesNumber.costPerDay
                          ? costPerDayArticle
                          : articleNumber === articlesNumber.costPerWeek
                            ? costPerWeekArticle
                            : articleNumber === articlesNumber.costPerMonth
                              ? costPerMonthArticle
                              : articleNumber === articlesNumber.costAgreement
                                ? costAgreementArticle
                                : articleNumber === articlesNumber.ExpenditureAccordingToTheAttachedPDF
                                  ? ExpenditureAccordingToTheAttachedPDF
                                  : '',
                },
              },
            ];
          });
          invoiceHours.push(...array);
        }
        const invoiceFile = Array(freelancer.length).fill([]);
        const element = invoiceHours.splice(invoiceHours.length - 1, 1)[0];
        invoiceHours.splice(0, 0, element);
        freelancer?.splice(freelancer.length - 1, 1);

        const otherArticles = workingHours?.filter((item) => {
          return (
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.TRAVEL ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
          );
        }).map((item) => {
          if (item.foodAllowance && item.totalDayOfTravels) {
            return {
              ...item,
              foodAllowance: item.foodAllowance / item.totalDayOfTravels
            };
          }
          return item;
        });;

        const selectedData = {
          selectedCustomer: customer,
          description,
          freelancer,
          invoiceHours,
          showDates,
          invoiceNumber,
          vat,
          isFixed,
          amount,
          invoiceFile,
          fetchInvoices,
          otherArticles,
          isBooked: fetchInvoices?.isBooked,
        };
        setLoading(false);
        dispatch(getInvoiceData(selectedData));
      } else {
        setLoading(false);
        toast.error('Something went wrong please try again.');
      }
      try {
        const res = await axios.get(`/admin/user/user/${result.data.response.createdBy}`);
        dispatch(invoiceCreatedUserDetails(res.data.response.user));
      } catch (err) {
        console.error(err);
      }
      
      // Mark that user is navigating away from invoice tabs to edit page
      // and preserve search state
      dispatch(setNavigatedAway(true));
      dispatch(setPreserveSearch(true));
      
      navigate(`/dashboard/invoice-tool/${result.data.response.createdBy}?edit=true`, {
        state: {
          invoiceNumber,
          invoiceDetails: result.data.response,
        },
      });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
  };

  const [isCreditNoteModalOpen, setIsCreditNoteModalOpen] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState({ invoiceNumber: '', amount: 0 });

  const handleOpenCreditNoteModal = (invoiceNumber, amount) => {
    setSelectedInvoice({ invoiceNumber, amount });
    setIsCreditNoteModalOpen(true);
  };

  const handleCloseCreditNoteModal = () => {
    setIsCreditNoteModalOpen(false);
  };

  // Add state for Credit Details modal and data
  const [isCreditDetailsModalOpen, setCreditDetailsModalOpen] = useState(false);
  const [creditDetails, setCreditDetails] = useState(null);

  // Function to fetch credit details
  const handleOpenCreditDetailsModal = async (invoiceNumber) => {
    setCreditDetails(null);
    setCreditDetailsModalOpen(true);
    try {
      setLoading(true);
      const response = await axios.get(`/AdminCreditInvoice/${invoiceNumber}`);
      if (response.status === 200) {
        setCreditDetails(response.data);
      }
    } catch (error) {
      toast.error('Failed to fetch credit details');
    } finally {
      setLoading(false);
    }
  };

  const handleCloseCreditDetailsModal = () => {
    setCreditDetailsModalOpen(false);
  };

  const handleAdditionalChargeNoteChange = (id, value) => {
    setAdditionalInvoiceCharges(
      additionalInvoiceCharges.map((row) =>
        row.id === id ? { ...row, reminderText: value, showCheck: shouldShowCheckIcon(value, row.feeValue) } : row
      )
    );
  };
  const handleCheckboxChange = (id, value) => {
    setAdditionalInvoiceCharges((prev) => prev.map((row) => (row.id === id ? { ...row, isAfterTax: value } : row)));
  };
  const handleFeeChange = (id, value) => {
    if (/^\d*\.?\d*$/.test(value)) {
      // Allows numbers and decimals
      setAdditionalInvoiceCharges(
        additionalInvoiceCharges.map((row) =>
          row.id === id ? { ...row, feeValue: value, showCheck: shouldShowCheckIcon(row.reminderText, value) } : row
        )
      );
    }
  };

  const formatToTwoDecimals = (value) => {
    const parsed = parseFloat(value);
    return !isNaN(parsed) ? parsed.toFixed(2) : '';
  };

  const addEditAdditionalCharges = async (id, isDeduct, isAfterTax, invoiceNumber, isNew) => {
    const row = additionalInvoiceCharges.find((row) => row.id === id);
    if (!row) {
      toast.error('Row not found.');
      return false;
    }

    const payload = {
      Id: isNew ? undefined : id, // Don't send ID in POST, but required in PUT
      InvoiceNumber: invoiceNumber,
      InvoiceAmount: row.feeValue || '0',
      //FreelancerUserId : invoiceFreelancer?. userId? invoiceFreelancer?.userId : createdBy,
      FreelancerUserId: selectedFreelancer || 0,
      Note: row.reminderText || '',
      isDeduct: isDeduct,
      isAfterTax: isAfterTax,
    };

    try {
      let response;
      if (isNew) {
        // First-time confirmation (POST API)
        response = await axios.post(`/AdminAdditionalInvoiceServiceFee`, payload);
        if (response.status === 200 && response.data.id) {
          toast.success(`'${row.reminderText}' has been successfully created!`);

          // Update row with the new ID from the API response
          setAdditionalInvoiceCharges(
            additionalInvoiceCharges.map((row) =>
              row.id === id && response.data.FreelancerUserId === selectedFreelancer
                ? { ...row, id: response.data.id, editing: false, showCheck: false, isNew: false }
                : row
            )
          );
          return response.data.id; // Return new ID for future PUT calls
        }
      } else {
        // Updating an existing entry (PUT API)
        response = await axios.put(`/AdminAdditionalInvoiceServiceFee`, payload);
        if (response.status === 200) {
          setAdditionalInvoiceCharges(
            additionalInvoiceCharges.map((row) =>
              row.id === id ? { ...row, id: response.data.id, editing: false, showCheck: false, isNew: false } : row
            )
          );
          toast.success(`'${row.reminderText}' has been successfully updated!`);
          return response.data.id;
        }
      }

      if (response.status === 200) {
        setAdditionalInvoiceCharges(
          additionalInvoiceCharges.map((row) =>
            row.id === id
              ? { ...row, id: isNew ? response.data.id : row.id, editing: false, showCheck: false, isNew: false }
              : row
          )
        );
        return true;
      }
    } catch (error) {
      toast.error('API request failed');
      return false;
    }
  };

  const shouldShowCheckIcon = (reminderText, feeValue) => {
    return reminderText.trim() !== '' && feeValue.trim() !== '' && feeValue !== '0';
  };

  const [isCheckIconDisabled, setIsCheckIconDisabled] = useState(false);

  const submitAddEditAdditionalCharges = async (id, invoiceNumber) => {
    setIsSubmitting(true);
    setIsCheckIconDisabled(true); // Disable the CheckIcon
    const row = additionalInvoiceCharges.find((row) => row.id === id);
    if (!row) return;

    const isNew = row.isNew; // Determine if the row is new
    const isDeduct = row.isDeduct;
    const isAfterTax = row.isAfterTax || false;
    const result = await addEditAdditionalCharges(id, isDeduct, isAfterTax, invoiceNumber, isNew);
    if (result) {
      await handleGetSalary(id, false, invoiceNumber);
      await loadAdditionalInvoiceServiceFee(invoiceNumber, selectedRow);
    }
    setIsSubmitting(false);
    setIsCheckIconDisabled(false); // Re-enable the CheckIcon
  };

  const handleEdit = (id) => {
    setAdditionalInvoiceCharges(
      additionalInvoiceCharges.map((row) => (row.id === id ? { ...row, editing: true, showCheck: true } : row))
    );
  };

  const handleCancel = async (id, row) => {
    try {
      if (id === 0) {
        toast.success(`${row.reminderText} removed`);
        setAdditionalInvoiceCharges((prev) => prev.filter((r) => r.id !== id));
        return;
      }

      const response = await axios.delete(`/AdminAdditionalInvoiceServiceFee/${row.id}`);
      if (response.status === 200) {
        await handleGetSalary(id, false, row.invoiceNumber);
        toast.success(`'${row.reminderText}' removed`);
        setAdditionalInvoiceCharges((prev) => prev.filter((r) => r.id !== id));
      }
    } catch (error) {
      toast.error('Failed to delete row.');
      console.error(error);
    }
  };

  const fetchInvoices = async () => {
    try {
      const userId = new URLSearchParams(search).get('userId');
      setLoading(true);
      let URL;
      if (searchDropValue && searchQuery) {
        URL = `/admin/invoice?PageSize=${rowsPerPage}&PageNumber=${page + 1
          }&active=${selectedTabValue}&searchQuery=${searchQuery}&SearchColumn=${searchDropValue}`;
      }
      else if (userIdFromParams) {
        if (defaultAllTabForUser) {
          dispatch(setInvoiceSelectedTabValue('8'));
        }

        URL = `/admin/invoice?PageSize=${rowsPerPage}&PageNumber=${page + 1
          }&active=${selectedTabValue}&searchQuery=${userIdFromParams}&SearchColumn=${6}`;
      } else {
        URL = `/admin/invoice?PageSize=${rowsPerPage}&PageNumber=${page + 1
          }&active=${selectedTabValue}&searchQuery=${searchQuery}`;
      }

      const res = await axios.get(URL);
      if (userIdFromParams) {
        setDefaultAllTabForUser(false);
      }

      if (res?.status === 200) {
        setLoading(false);

        const invoices = res.data.response?.map((invoice) => ({
          ...invoice,
          customer: {
            ...invoice.customer,
            customerId: invoice.customer?.customerId || '',
            isSsnValid: invoice.customer?.isSsnValid,
            isSsnExist: invoice.customer?.isSsnExist
          },
          customerName: invoice.customer?.name || '',
          invoiceFileUpload: invoice.invoiceFileUpload[0] && invoice.invoiceFileUpload[0].fortnoxFileId,
          isBooked: invoice?.isBooked || false,
          isEmailSent: invoice?.isEmailSent,
          workingHours: invoice?.workingHours?.map((item) => ({
            ...item,
              isEmailSent: invoice?.isEmailSent,
            
            number: item.number.toString().concat(item.unit),
            amountPerUnit: item?.amountPerUnit
              ?.toString()
              .concat(
                ' ',
                `SEK${item.unit === 'km' ? '' : '/'}${(item.unit !== 'km' && (item.unit === 'förp' ? 'Antal' : item.unit)) || ''
                }`
              ),
            expressFee: item?.expressFee ? item?.expressFee : 0,
            grossAmount: item?.grossAmount ? item?.grossAmount : 0,
          })),
          toPayAmont: invoice?.toPayAmont ? invoice?.toPayAmont : 0,
          totalGrossAmount: invoice?.totalGrossAmount ? invoice?.totalGrossAmount : 0,
          isSelected: invoice.createdBy === Number(userId),
        }));

        setoriginalInvoice(invoices);

        // Apply search filter if search query exists
        let filteredRows;
        if (searchQuery) {
          filteredRows = applySortFilter(invoices, getComparator(order, orderBy), searchQuery, invoices);
        } else {
          filteredRows = applySortFilter(invoices, getComparator(order, orderBy), '', invoices);
        }
        
        const invoiceNumber = new URLSearchParams(search).get('notificationVal');

        const notificationFilteredList = filteredRows?.map((item) => ({
          ...item,
          isSelected: item.invoiceNumber === Number(invoiceNumber),
        }));

        selectAllClick(isAllSelected, notificationFilteredList);
        setInvoices(notificationFilteredList);
        setFilteredInvoices(notificationFilteredList);
        setTotalCount(res.data.totalCount);
        if (selectedTabValue === '1' || selectedTabValue === '5' || selectedTabValue === '2') {
          setHideCheckboxColumn(false);
        } else {
          setHideCheckboxColumn(true);
        }
      }
    } catch (err) {
      if (err?.response?.data?.message === 'Something went wrong please try again after sometime.') {
        fetchInvoices();
        setLoading(true);
      } else {
        setInvoices([]);
        setFilteredInvoices([]);
        setLoading(false);
      }
      console.log(err);
    }
  };

  useEffect(() => {
    dispatch(fetchGlobalData());
  }, [dispatch]);

  const downloadPDF = async (invoiceNumber) => {
    try {
      setLoading(true);

      const res = await axios.get(`/admin/invoice/file/download/${invoiceNumber}`);

      if (res.data?.response && Array.isArray(res.data.response)) {
        res.data.response.forEach((base64PDF, index) => {
          const linkSource = `data:application/pdf;base64,${base64PDF}`;
          const downloadLink = document.createElement('a');
          const fileName = `invoice_${invoiceNumber}_${index + 1}.pdf`; // Generate unique file names
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
        });
      } else {
        console.error('Invalid response format');
      }

      setLoading(false);
    } catch (error) {
      console.error('Error downloading PDFs:', error.message || error);
      setLoading(false);
    }
  };

  const createSalary = async (invoiceNumber) => {
    try {
      setLoading(true);
      const invoiceNumbersArray = Array.isArray(invoiceNumber) ? invoiceNumber : [invoiceNumber];
      const result = await axios.post(`/admin/invoice/create-salary`, {
        InvoiceNumbers: invoiceNumbersArray,
        IsPaid: false
      });
      
      if (result?.data?.statusCode === 200 || (result?.status === 200 && result?.data?.response !== false)) {
        setAlertMessage(`Salary has been created successfully.`);
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        await fetchInvoices();
      } else {
        setAlertMessage(result?.data?.message || 'Failed to create salary');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'An error occurred while creating salary';
      setAlertMessage(errorMessage);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    const filteredRows = applySortFilter(
      filteredInvoices,
      getComparator(isAsc ? 'desc' : 'asc', orderBy),
      event.target.value,
      originalInvoice
    );
    setFilteredInvoices(filteredRows);
  };

  const selectAllClick = (isSelected, filteredInvoices) => {
    if (isSelected) {
      const newSelecteds = filteredInvoices?.map((n) => n.id);
      const newSelectedInvoiceNumber = filteredInvoices?.map((n) => n.invoiceNumber);
      setSelected(newSelecteds);
      setInvoiceSelected(newSelectedInvoiceNumber)
      return;
    }
    setSelected([]);
    setInvoiceSelected([]);
  };

  const handleSelectAllClick = (event) => {
    setAllSelected(event.target.checked);
    selectAllClick(event.target.checked, filteredInvoices);
  };

  const handleDownloadSinglePdf = async (fileName, fileContent, fortnoxFileId, createdDate) => {
    try {
      setLoading(true);
      const blobLaunchedDate = new Date('2024-11-14');
      blobLaunchedDate.setHours(0, 0, 0, 0);
      const fileCreatedDate = new Date(createdDate);
      fileCreatedDate.setHours(0, 0, 0, 0);
      let fileBytes;
      let res;
      if (fileContent !== '') {
        fileBytes = fileContent;
      } else if (fileName && fileCreatedDate >= blobLaunchedDate) {
        res = await axios.get(`/admin/invoice/download/${fileName}`);
        fileBytes = res?.data?.response;
      } else {
        res = await axios.get(`/admin/invoice/download/fortnox-file/${fortnoxFileId}`);
        fileBytes = res?.data?.response;
      }
      const linkSource = `data:application/pdf;base64,${fileBytes}`;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = fileName.endsWith('.pdf') ? fileName : `${fileName}.pdf`;
      downloadLink.click();

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSingleSelectClick = (event, id, invoiceNumber) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
    const selectedIndexInvoiceNumber = invoiceSelected.indexOf(invoiceNumber);
    let newSelectedInvoiceNumber = [];
    if (selectedIndexInvoiceNumber === -1) {
      newSelectedInvoiceNumber = newSelectedInvoiceNumber.concat(invoiceSelected, invoiceNumber);
    } else if (selectedIndexInvoiceNumber === 0) {
      newSelectedInvoiceNumber = newSelectedInvoiceNumber.concat(invoiceSelected.slice(1));
    } else if (selectedIndexInvoiceNumber === invoiceSelected.length - 1) {
      newSelectedInvoiceNumber = newSelectedInvoiceNumber.concat(invoiceSelected.slice(0, -1));
    } else if (selectedIndexInvoiceNumber > 0) {
      newSelectedInvoiceNumber = newSelectedInvoiceNumber.concat(invoiceSelected.slice(0, selectedIndexInvoiceNumber), invoiceSelected.slice(selectedIndexInvoiceNumber + 1));
    }
    setInvoiceSelected(newSelectedInvoiceNumber);

  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilter = (event) => {
    // Update Redux store instead of local state
    dispatch(setInvoiceSearchQuery(event.target.value));
    if (event.target.value) {
      const filteredRows = applySortFilter(
        filteredInvoices,
        getComparator(order, orderBy),
        event.target.value,
        originalInvoice
      );

      setFilteredInvoices(filteredRows);
    } else {
      setFilteredInvoices(originalInvoice);
    }
  };

  const isNotFound = filteredInvoices.length === 0;

  const handleGetSalary = async (id, isMultiFreelancer, invoiceNumber) => {
    try {
      setLoading(true);
      await axios.get(`/admin/invoice/${invoiceNumber}`).then((res) => {
        const rowData = res.data.response;
        rowData.id = id;
        setPdfLang(rowData.invoiceLanguage?.toLowerCase() === "sv-se" ? "sv-se" : "en-us");
        setSelectedRow(rowData);
        setSelectedRowInvoiceNumber(rowData.invoiceNumber);
        setUserPdf(res.data.response?.invoiceFileUpload);

        if (!isMultiFreelancer) {
          setIsOpenModal(() => ({ open: true }));
        }
        if (selectedFreelancer != 0) {
          const freelancer = res.data.response?.salaryFreelancer?.find((item) => item.userId === selectedFreelancer);
          setSelectedRow({
            ...freelancer,
            customer: { 
              name: freelancer.name,
              customerId: rowData.customer?.customerId,
              country: rowData.customer?.country,
              email: rowData.customer?.email,
              orgNo: rowData.customer?.orgNo,
              ssn: rowData.customer?.ssn,
              isSsnValid: rowData.customer?.isSsnValid,
              isSsnExist: rowData.customer?.isSsnExist,
            },
            createdDate: res.data.response.date,
            userId: freelancer.userId,
            id: id,
            isUserUploadedToComplyCube: rowData?.isUserUploadedToComplyCube,
            isBooked: rowData.isBooked,
            invoiceNumber: rowData.invoiceNumber, 
            dueDate: rowData.dueDate, 
          });
          setSelectedFreelancer(selectedFreelancer);
        }
        if (!rowData.salaryFreelancer) {
          loadAdditionalInvoiceServiceFee(rowData.invoiceNumber, rowData);
        }
      });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveInvozioFee = async (item, invoiceNo) => {
    try {
      setLoading(true);
      const userId = item.userId ? item.userId : item.workingHours[0].userId;
      const invoiceId = item.workingHours?.[0]?.invoiceId;
      const res = await axios.put(
        `/AdminAdditionalInvoiceServiceFee/set-Invozio-fee/${item.id}/${userId}`
      );
      if (res.status === 200) {
        toast.success(`Platform fee removed successfully.`);
        await loadAdditionalInvoiceServiceFee(invoiceId, item);
        await handleGetSalary(item.id, false, invoiceNo)
      }
    }
    catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  const handleOpenFreelancerModal = (item, date, userId, rowId,selectedRow) => {
    if (rowId) {
      item.id = rowId;
    }
    setSelectedFreelancer(userId);
    setIsOpenModal(() => ({ open: true }));
    setSelectedRow({ 
      ...item, 
      customer: { 
        customerId: selectedRow?.customer?.customerId,
        name: item.name,
        country: selectedRow?.customer?.country,
        email: selectedRow?.customer?.email || item?.email || '',
        orgNo: selectedRow?.customer?.orgNo,
        ssn: selectedRow?.customer?.ssn,
        isSsnValid: selectedRow?.customer?.isSsnValid,
        isSsnExist: selectedRow?.customer?.isSsnExist,
      },
      invoiceNumber: selectedRow.invoiceNumber, 
      createdDate: date,
      email: selectedRow?.customer?.email || item?.email || '',
      userId: userId,
      isBooked: selectedRow.isBooked, 
      isUserUploadedToComplyCube: selectedRow?.salaryFreelancer?.find((freelancer) => freelancer.userId === userId)?.isUserUploadedToComplyCube,
      dueDate: selectedRow.dueDate, 
      isHaveCreditInvoice: selectedRow.isHaveCreditInvoice,
      invoicePurposeType: selectedRow.invoicePurposeType,
      creditInvoiceNumber: selectedRow.creditInvoiceNumber,
    });
  };

  // useEffect(()=>{
  //   setSelectedRow(setSelectedRow)
  // },[])

  const loadAdditionalInvoiceServiceFee = async (invoiceNumber, freelancer) => {
    try {
      setLoading(true);
      const res = await axios.get(
        `/AdminAdditionalInvoiceServiceFee/admin/${invoiceNumber}/${freelancer?.userId
          ? freelancer?.userId
          : freelancer?.createdBy
            ? freelancer?.createdBy
            : selectedRow.createdBy
        }`
      );
      const invoiceData = res.data;
      // Transform API response into table format
      const newRows = invoiceData.map((item) => ({
        id: item.id, // Unique ID from API
        invoiceNumber: item.invoiceNumber,
        reminderText: item.note,
        isAfterTax: item.isAfterTax,
        feeValue: item.invoiceAmount.toString(),
        isDeduct: item.isDeduct, // Get IsDeduct value
        editing: false,
        showCheck: false,
        isNew: false, // Indicate this row is from API
        freelancerUserId: item.freelancerUserId,
      }));

      setAdditionalInvoiceCharges(newRows);
    } catch (err) {
      toast.error('Failed to fetch invoice data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getArticles = (number) => {
    switch (number) {
      case articlesNumber.HourlyWages:
        return HourlyWages;
      case articlesNumber.otherCost:
        return otherCost;
      case articlesNumber.costPerDay:
        return costPerDayArticle;
      case articlesNumber.costPerWeek:
        return costPerWeekArticle;
      case articlesNumber.costPerMonth:
        return costPerMonthArticle;
      case articlesNumber.costAgreement:
        return costAgreementArticle;
      case articlesNumber.ExpenditureAccordingToTheAttachedPDF:
        return ExpenditureAccordingToTheAttachedPDF;
      default:
        return '';
    }
  };

  const adminInvoiceReminder = async (invoiceNumber) => {
    try {
      setLoading(true);
      const URL = `/AdminReminderInvoice/reminderInvoice/${invoiceNumber}`;

      const result = await axios.put(URL);

      if (result?.status === 200) {
        setAdminInvoiceReminderCheck(true);
        toast.success(`Reminder invoice created for Invoice Number #${invoiceNumber}`);
        fetchInvoices();
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  // handle edit Invoice
  const handleEditInvoice = async (invoiceNumber, row) => {
    try {
      setLoading(true);
      
      
      const URL = `/admin/invoice/get-invoice/${invoiceNumber}`;

      const result = await axios.get(URL);
      setGetEditInvoiceData(result.data.response);
      if (result?.status === 200) {
        const fetchInvoices = result?.data?.response;
        const {
          vat,
          amount,
          isFixed,
          customer,
          showDates,
          invoiceNumber,
          description,
          invoiceFreelancer,
          workingHours,
          holidaySavings,
          holidaySavingsFee,
          pension,
          pensionAmount,
          file,
          dueDate,
          invoiceToolVersion = 1,
        } = fetchInvoices; 

        const filteredWorkingHours = workingHours?.filter((item) => {
          return (
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MILEAGE_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY &&
            item?.articleNumber !== ARTICLE_NUMBERS.TRAVEL &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX &&
            item?.articleNumber !== ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
          );
        });

        const freelancer =
          invoiceFreelancer?.length > 0
            ? invoiceFreelancer?.map((item) => ({
              amount: item.amount,
              userId: item.userId,
               holidaySavings: item.holidaySavings,
              holidaySavingsFee: item.holidaySavingsFee,
              pension: item.pension,
              pensionAmount: item.pensionAmount,
              signUpUser: item.freelancerDetails,
            }))
            : [];

        const invoiceHours = [];

        if (freelancer && freelancer.length !== 0) {
          freelancer?.forEach((freelancers) => {
            let array = [];
            filteredWorkingHours?.forEach((item) => {
              const { amountPerUnit, number, articleNumber, workingDate, userId, houseworkType, dateId, id, customWorkingDescription} = item;

              // Check if userId is present in freelancers.userId array
              if (userId === freelancers?.userId) {
                array = [
                  {
                    ...array[0],
                    [dateId ? dateId : workingDate.split('T')[0]]: {
                      units: number,
                      userId: userId,
                      amount: amountPerUnit,
                       id: id,
                      houseworkType: {
                        value: houseworkType,
                        name: convertHouseworkType(houseworkType),
                      },
                      customWorkingDescription: customWorkingDescription,
                      article:
                        articleNumber === articlesNumber.HourlyWages
                          ? HourlyWages
                          : articleNumber === articlesNumber.otherCost
                            ? otherCost
                            : articleNumber === articlesNumber.costPerDay
                              ? costPerDayArticle
                              : articleNumber === articlesNumber.costPerWeek
                                ? costPerWeekArticle
                                : articleNumber === articlesNumber.costPerMonth
                                  ? costPerMonthArticle
                                  : articleNumber === articlesNumber.costAgreement
                                    ? costAgreementArticle
                                    : articleNumber === articlesNumber.ExpenditureAccordingToTheAttachedPDF
                                      ? ExpenditureAccordingToTheAttachedPDF
                                      : '',
                    },
                  },
                ];
              }
            });
            invoiceHours.push(...array);
          });
        } else {
          let array = [];
          filteredWorkingHours?.forEach((item) => {
            const { amountPerUnit, number, articleNumber, workingDate, houseworkType, dateId, userId, id,vat,customWorkingDescription } = item;

            array = [
              {
                ...array[0],
                [dateId ? dateId : workingDate.split('T')[0]]: {
                  units: number,
                  id: id,
                  userId: userId,
                  amount: amountPerUnit,
                  houseworkType: {
                    value: houseworkType,
                    name: convertHouseworkType(houseworkType),
                  },
                  customWorkingDescription: customWorkingDescription,
                  article:
                    articleNumber === articlesNumber.HourlyWages
                      ? HourlyWages
                      : articleNumber === articlesNumber.otherCost
                        ? otherCost
                        : articleNumber === articlesNumber.costPerDay
                          ? costPerDayArticle
                          : articleNumber === articlesNumber.costPerWeek
                            ? costPerWeekArticle
                            : articleNumber === articlesNumber.costPerMonth
                              ? costPerMonthArticle
                              : articleNumber === articlesNumber.costAgreement
                                ? costAgreementArticle
                                : articleNumber === articlesNumber.ExpenditureAccordingToTheAttachedPDF
                                  ? ExpenditureAccordingToTheAttachedPDF
                                  : '',
                                  vat: vat,
                },
              },
            ];
          });
          invoiceHours.push(...array);
        }
        const invoiceFile = Array(freelancer.length).fill([]);
        // const element = invoiceHours.splice(invoiceHours.length - 1, 1)[0];
        // invoiceHours.splice(0, 0, element);
        // freelancer?.splice(freelancer.length - 1, 1);

        const otherArticles = workingHours?.filter((item) => {
          return (
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MILEAGE_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_OUT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_HALF_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_WITH_TAX_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.ALLOWANCE_IN_TAX_FREE_FULL_DAY ||
            item?.articleNumber === ARTICLE_NUMBERS.TRAVEL ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_TAX_FREE ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX ||
            item?.articleNumber === ARTICLE_NUMBERS.MATERIAL_VAT_WITH_TAX_WITHOUT_PDF
          );
        }).map((item) => {
          if (item.foodAllowance && item.totalDayOfTravels) {
            return {
              ...item,
              foodAllowance: item.foodAllowance / item.totalDayOfTravels
            };
          }
          return item;
        });;

        const selectedData = {
          selectedCustomer: customer,
          description,
         freelancer: freelancer,
          invoiceHours,
          showDates,
          invoiceNumber,
          vat,
          isFixed,
          amount,
          invoiceFile,
          fetchInvoices,
          otherArticles,
          holidaySavings,
          holidaySavingsFee,
          pension,
          pensionAmount,
          invoiceToolVersion,
          isBooked: row?.isBooked || fetchInvoices?.isBooked, // Pass booking status to edit form
          dueDate, // Include due date in the data passed to Redux
        };
        setLoading(false);
        dispatch(getInvoiceData(selectedData));
      } else {
        setLoading(false);
        toast.error('Something went wrong please try again.');
      }
      try {
        const res = await axios.get(`/admin/user/user/${result.data.response.createdBy}`);
        dispatch(invoiceCreatedUserDetails(res.data.response.user));
      } catch (err) {
        console.error(err);
      }
      
      // Mark that user is navigating away from invoice tabs to edit page
      // and preserve search state
      dispatch(setNavigatedAway(true));
      dispatch(setPreserveSearch(true));
      if(result.data.response.createdDate){
      navigate(`/dashboard/invoice-tool/${result.data.response.createdBy}?edit=true&createdDate=${result.data.response.createdDate}`);
      }
      else{
              navigate(`/dashboard/invoice-tool/${result.data.response.createdBy}?edit=true`);
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  // notes module
  const fetchCommentList = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/admin/invoice/get-notes?invoiceNumber=${selectedInvoiceNumber}`);
      setcommentList(res?.data?.response);
    } catch (err) {
      setcommentList([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (toggleNote) {
      fetchCommentList();
    }
  }, [toggleNote]);

  const addnoteToggle = (id) => {
    setToggleNote(true);
    setSelectedUserId(id);
  };
  const postAddnotes = async () => {
    try {
      if (notesContent === '' || notesContent.trim() === '') {
        setIsNotesContentEmpty(true);
        setNotesContent('');
      } else {
        setIsNotesContentEmpty(false);
        setLoading(true);
        const payload = {
          userId: 0,
          invoiceNumber: selectedInvoiceNumber,
          description: notesContent,
        };
        const response = await axios.post('/admin/invoice/notes', payload);
        if (response?.status === 200) {
          setLoading(false);
          fetchCommentList();
          setNotesContent('');
          toast.success('Notes added successfully');
          fetchInvoices();
        } else {
          setLoading(false);
          toast.error('Server Error! Please try again');
        }
      }
    } catch (err) {
      setLoading(false);
      toast.error(err?.response?.data?.message);
      setAlertStatus('error');
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteNotes = async () => {
    try {
      const noteIdsToDelete = selectedNotes.map(index => commentList[index]?.id).filter(id => id);
      
      if (noteIdsToDelete.length > 0) {
      setLoading(true);
      const response = await axios.put('/admin/invoice/delete-notes', {
        invoiceNumber: selectedInvoiceNumber,
        notesId: noteIdsToDelete
      });
        
        if (response.statusCode === 200 || response?.status === 200) {
          setLoading(false);
          setSelectedNotes([]);
          setDeleteNotesModal({ show: false });
          setToggleNote(false);
          setNotesContent('');
          setIsNotesContentEmpty(false);
          toast.success('Notes deleted successfully');
          fetchInvoices();
        } else {
          setLoading(false);
          toast.error('Failed to delete notes');
        }
      }
    } catch (error) {
      setLoading(false);
      console.error('Error deleting notes:', error);
      toast.error('An error occurred while deleting notes');
    }
  };

  const handleSnackBarClose = () => {
    setIsSnackBarOpen(false);
  };

  const handleModalRef = (node) => {
    if (node && isOpenModal.open && !hasScrolledToTop) {
      node.scrollTop = 0; // Scroll to the top when the modal opens for the first time
      setHasScrolledToTop(true); // Mark as scrolled to top
    }
  };
  const handleCloseModal = () => {
    setHasScrolledToTop(false);
    setIsOpenModal((prevState) => ({ ...prevState, open: false }));
    setSelectedFreelancer(0);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    overflow: 'auto',
  };

  const commentStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    width: '60%',
    height: '80%',
    marginBottom: '40',
    p: 3,
  };

  const cancelInvoice = async (invoiceNumber) => {
    try {
      setLoading(true);
      await axios.put(`/admin/invoice/${invoiceNumber}?isActive=false`).then(async () => {
        setAlertMessage(`Invoice Number #${invoiceNumber} has been cancelled successfully.`);
        setAlertStatus('success');
        setAutoHideDuration(2000);
        setIsSnackBarOpen(true);
        await fetchInvoices();
      });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const activateOrDeactivate = async (invoiceNumber, type) => {
    try {
      setLoading(true);
      await axios.put(`/admin/invoice/admin/${invoiceNumber}?isActive=${JSON.parse(type)}`).then(async () => {
        setAlertMessage(
          `Invoice Number #${invoiceNumber} has been ${type === 'true' ? 'Activated' : 'Deactivated'} successfully.`
        );
        setAlertStatus('success');
        setAutoHideDuration(2000);
        setIsSnackBarOpen(true);
        await fetchInvoices();
        setActivateModal({ show: false });
      });
    } catch (err) {
      setActivateModal({ show: false });
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setActivateModal({ show: false });
      setLoading(false);
    }
  };

  const handleTabChange = (e, newValue) => {
    // Don't clear search when changing tabs - keep search persistent
    // dispatch(setInvoiceSearchQuery(''));
    setPage(0);
    setSelected([]);
    setInvoiceSelected([]);

    dispatch(setInvoiceSelectedTabValue(newValue));
    setAllSelected(false);
    if (newValue === '1') {
      setHideCheckboxColumn(true);
    } else if (newValue === '2') {
      setHideCheckboxColumn(true);
    } else if (newValue === '3') {
      setHideCheckboxColumn(false);
    }
  };

  const handleDelete = async () => {
    await deleteInvoices();
  };

  const handleCreateSalary = async () => {
    await createSalary(invoiceSelected);
  };

  const handleBookingSuccess = () => {
    // Refresh the invoices list after successful booking
    fetchInvoices();
  };

  const getSelectedInvoiceObjects = () => {
    return filteredInvoices.filter(invoice => 
      invoiceSelected.includes(invoice.invoiceNumber)
    );
  };

  const deleteInvoices = async () => {
    try {
      setLoading(true);
      await axios.delete('/admin/invoice', { data: selected }).then((res) => {
        const isDeletedCount = res.data.response.isDeleted;
        if (isDeletedCount > 0) {
          setAlertMessage(
            `${isDeletedCount === res.data.totalCount
              ? `Selected ${isDeletedCount > 1 ? 'invoices' : 'invoice'} has been deleted successfully.`
              : `${isDeletedCount} ${isDeletedCount > 1 ? 'invoices' : 'invoice'} out of ${res.data.totalCount
              } has been deleted successfully.`
            }`
          );
          setAlertStatus('success');
        } else {
          setAlertMessage(`Selected ${isDeletedCount > 1 ? 'invoices' : 'invoice'} can't been deleted.`);
          setAlertStatus('error');
        }
        setIsSnackBarOpen(true);
        fetchInvoices();
      });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
      setSelected([]);
      setInvoiceSelected([]);
    }
  };

  const handleChangeSalaryDropdown = (event) => {
    setFreelancerName(event.target.value);
  };

  const handleUndoCreate = async (invoiceNumber) => {
    try {
      setLoading(true);
      await axios.delete(`/admin/invoice/delete-salary/${invoiceNumber}`).then(async () => {
        setAlertMessage(`Salary ${invoiceNumber} has been deleted successfully.`);
        setAlertStatus('success');
        setAutoHideDuration(2000);
        setIsSnackBarOpen(true);
        await fetchInvoices();
      });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleExpressPayoutChange = (event, id, invoiceNumber) => {
    setExpressPaymentModal({
      id,
      show: true,
      type: event.target.checked,
      invoiceNumber,
    });
  };

  const handleCancelExpressPayment = () => {
    setExpressPaymentModal({
      show: false,
    });
  };

  const handleCreateExpressPayment = async () => {
    try {
      setLoading(true);
      await axios
        .put(`/admin/invoice/express/${expressPaymenttModal.invoiceNumber}?express=${expressPaymenttModal.type}`)
        .then(async (res) => {
          setAlertMessage(res?.data?.response);
          setAlertStatus('success');
          setAutoHideDuration(2000);
          setIsSnackBarOpen(true);
          const updatedInvoices = filteredInvoices?.map((row) => {
            if (row.id === expressPaymenttModal.id) {
              return { ...row, expressPayout: expressPaymenttModal.type };
            }
            return row;
          });
          setFilteredInvoices(updatedInvoices);
          setExpressPaymentModal({
            show: false,
          });
          await fetchInvoices();
        });
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  // Activate API Function Helper
  const handleActivateInvoice = async (invoiceNumber, type) => {
    try {
      setLoading(true);
      const result = await axios.put(`/admin/invoice/admin/${invoiceNumber}?isActive=${JSON.parse(type)}`);
      if (result?.status === 200) {
        setAlertMessage(`Invoice Number #${invoiceNumber} has been ${type === 'true' && 'Activated'} successfully.`);
        setAlertStatus('success');
        setAutoHideDuration(2000);
        setIsSnackBarOpen(true);
        await fetchInvoices();
        settoggleIsActive({ show: false });
      }
    } catch (err) {
      settoggleIsActive({ show: false });
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      settoggleIsActive({ show: false });
      setLoading(false);
    }
  };

  const handlePaidSalary = async (data) => {
    const { invoiceNumber, type } = data;

    try {
      setLoading(true);

      let url;
      let payload = null;

      if (type === 'unpaid') {
        url = `/admin/invoice/changes-in-status-of-invoice?invoiceNumber=${invoiceNumber}`;
      } else if (type === 'paid') {
        payload = {
          InvoiceNumbers: [invoiceNumber],
          IsPaid: true,
        };
        url = `/admin/adminSalary/create-salary`;
      }

      if (url) {
        const result = await axios.post(url, payload);
        if (result?.data?.statusCode === 200 || (result?.status === 200 && result?.data?.response !== false)) {
          setAlertMessage(`Invoice has been ${type === 'unpaid' ? 'unpaid' : 'paid'} successfully.`);
          setAlertStatus('success');
          setIsSnackBarOpen(true);
          await fetchInvoices();
        } else {
          setAlertMessage(result?.data?.message || 'Failed to update invoice status');
          setAlertStatus('error');
          setIsSnackBarOpen(true);
        }
      }
    } catch (err) {
      const errorMessage = err?.response?.data?.message || err?.message || 'An error occurred';
      setAlertMessage(errorMessage);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };


  const handleChangeSalaryStatus = async (data) => {
    const { invoiceNumber } = data;
    try {
      setLoading(true);
      const url = `/admin/invoice/manually-salarystatus-change?invoiceNumber=${invoiceNumber}`;
      await axios.post(url).then(() => {
        setAlertMessage(`Status has been updated successfully.`);
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        fetchInvoices();
      });
      await fetchInvoices();
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeSalaryStatusUnpaid = async (data) => {
    const { invoiceNumber } = data;
    try {
      setLoading(true);
      const url = `/admin/invoice/manually-salarystatus-change-to-unpaid?invoiceNumber=${invoiceNumber}`;
      await axios.post(url).then(() => {
        setAlertMessage(`Status has been updated successfully.`);
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        fetchInvoices();
      });
      await fetchInvoices();
    } catch (err) {
      setAlertMessage(err?.response?.data?.message);
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSyncProceed = async () => {
    try {
      setLoading(true);
      const Url = '/admin/invoice/sync-all-data-to-fortnox';
      const result = await axios.post(Url);

      if (result?.data?.message === 'error') {
        setMessages({
          customerUpdatedOnFortnoxError: result?.data?.response?.customerUpdatedOnFortnoxError,
          customeraddedOnFortnoxError: result?.data?.response?.customeraddedOnFortnoxError,
          invoiceCanceledOnFortnoxError: result?.data?.response?.invoiceCanceledOnFortnoxError,
          invoiceFileuploadedOnFortnoxError: result?.data?.response?.invoiceFileuploadedOnFortnoxError,
          invoiceTaxReductioncreatedOnFortnoxError: result?.data?.response?.invoiceTaxReductioncreatedOnFortnoxError,
          invoiceUpdatedOnFortnoxError: result?.data?.response?.invoiceUpdatedOnFortnoxError,
          invoiceaddedOnFortnoxError: result?.data?.response?.invoiceaddedOnFortnoxError,

          // Without Error Data
          customerUpdatedOnFortnox: result?.data?.response?.customerUpdatedOnFortnox,
          customeraddedOnFortnox: result?.data?.response?.customeraddedOnFortnox,
          invoiceCanceledOnFortnox: result?.data?.response?.invoiceCanceledOnFortnox,
          invoiceFileuploadedOnFortnox: result?.data?.response?.invoiceFileuploadedOnFortnox,
          invoiceTaxReductioncreatedOnFortnox: result?.data?.response?.invoiceTaxReductioncreatedOnFortnox,
          invoiceUpdatedOnFortnox: result?.data?.response?.invoiceUpdatedOnFortnox,
          invoiceaddedOnFortnox: result?.data?.response?.invoiceaddedOnFortnox,
        });
        setisError(true);
        setshowSyncModal(false);
        toast.error('Fortnox token is invalid');
      }
      if (result?.data?.message === 'Success') {
        toast.success('The Entire data of customer and invoice is sync to fortnox');
        setMessages({
          customerUpdatedOnFortnox: result?.data?.response?.customerUpdatedOnFortnox,
          customeraddedOnFortnox: result?.data?.response?.customeraddedOnFortnox,
          invoiceCanceledOnFortnox: result?.data?.response?.invoiceCanceledOnFortnox,
          invoiceFileuploadedOnFortnox: result?.data?.response?.invoiceFileuploadedOnFortnox,
          invoiceTaxReductioncreatedOnFortnox: result?.data?.response?.invoiceTaxReductioncreatedOnFortnox,
          invoiceUpdatedOnFortnox: result?.data?.response?.invoiceUpdatedOnFortnox,
          invoiceaddedOnFortnox: result?.data?.response?.invoiceaddedOnFortnox,
        });
        setisError(true);
      }
      fetchInvoices();
    } catch (err) {
      toast.error(err?.message);
    } finally {
      setLoading(false);
      setshowSyncModal(false);
    }
  };

  const handleButtonClick = async (customerId) => {
    setLoading(true);
    try {
      const result = await axios.post(`/admin/user/sent-incorrect-info-mail?id=${customerId}&type=1`);
      if (result?.data?.message === 'Success') {
        toast.success(result?.data?.response);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchInvoiceDetails = async (invoiceNumber) => {
    try {
      setLoading(true);
      const URL = `/admin/invoice/get-invoice/${invoiceNumber}`;
      const result = await axios.get(URL);

      if (result?.status === 200) {
        const fetchedInvoice = result?.data?.response;
        setInvoiceDetails(fetchedInvoice); // Save response in state
      }
    } catch (error) {
      console.error('Error fetching invoice details:', error);
    } finally {
      setLoading(false);
    }
  };

  const getBackgroundColor = (row, selectedTabValue) => {
    if (['2', '4', '5', '6'].includes(selectedTabValue)) {
      if (row?.isSelected) {
        return 'lightgrey';
      }
      if (row?.dueDate && new Date() > new Date(row.dueDate))
      {
        return '#ffcccc'; // Light red for overdue invoices

      }
      if (
        !row?.isInvoiceAddedOnFortnox ||
        !row?.isInvoiceUpdatedOnFortnox ||
        !row?.isInvoiceCanceledOnFortnox ||
        !row?.isTaxReductioncreatedOnFortnox ||
        !row?.isFileuploadedOnFortnox
      ) {
        return '#efe6f7ff';
      }
       if(!row?.isBooked)
      {
       return '#fbf9b3ff';
      }
      else if (row?.isBooked) {return '#ffffffff';}
    }
     if (selectedTabValue === '1') {
      if (
        row?.isEditInvoiceRequested === true
      ) {
        return '#c5f4f6';
      }else if ( !row?.isInvoiceAddedOnFortnox ||
        !row?.isInvoiceUpdatedOnFortnox ||
        !row?.isInvoiceCanceledOnFortnox ||
        !row?.isTaxReductioncreatedOnFortnox ||
        !row?.isFileuploadedOnFortnox){
            return '#efe6f7ff';

        }
        else if(!row?.isBooked)
      {
       return '#fbf9b3ff';
      }
      else if (row?.isBooked) {return '#ffffffff';}
    }

    if (selectedTabValue === '3') {
      if (
        row?.invoiceSalaryStatus === 2 || row?.invoiceSalaryStatus === 2
      ) {
        return '#a4f07166';
      }
      if (
        row?.invoiceSalaryStatus === 1
      ) {
        return '#ffff005c';
      }
      return '';
    }

    return '';
  };

   const handleComplyCube = async (userId) => {
    try {
      setLoading(true);
      const response = await axios.post(`admin/user/send-details-complycube?userId=${userId}`);
      if (response?.data?.statusCode === 200) {
        setAlertMessage('User uploaded to ComplyCube successfully');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        handleCloseModal();
      }
      else {
        setAlertMessage(response?.data?.message || 'Failed to upload to ComplyCube');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message || 'Failed to upload to ComplyCube');
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCustomerComplyCube = async (customerId) => {
    try {
      console.log(customerId,'customerId'); 
      setLoading(true);
      const response = await axios.post(`admin/user/send-customer-details-complycube?userId=${customerId}`);
      if (response?.data?.statusCode === 200) {
        setAlertMessage('Customer uploaded to ComplyCube successfully');
        setAlertStatus('success');
        setIsSnackBarOpen(true);
        await fetchInvoices();
        handleCloseModal();
      }
      else {
        setAlertMessage(response?.data?.message || 'Failed to upload to ComplyCube');
        setAlertStatus('error');
        setIsSnackBarOpen(true);
      }
    } catch (err) {
      setAlertMessage(err?.response?.data?.message || 'Failed to upload to ComplyCube');
      setAlertStatus('error');
      setIsSnackBarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const renderInvoices = () => (
    <>
      {selectedTabValue === '2' || selectedTabValue === '3' || selectedTabValue === '1' || selectedTabValue === '5' || selectedTabValue === '6' || selectedTabValue === '7' || selectedTabValue === '8' || selectedTabValue === '9' || selectedTabValue === '10'? (
        <>
          {!userIdFromParams && (
            <ListToolbar
              hideEmailButton={'true'}
              numSelected={selected.length}
              searchQuery={searchQuery}
              onFilter={handleFilter}
              onDelete={handleDelete}
              handleCreateSalary={handleCreateSalary}
              dropOptions={invoiceDropOptions}
              searchDropValue={searchDropValue}
              setSearchDropValue={(value) => dispatch(setInvoiceSearchDropValue(value))}
              selectedTabValue={selectedTabValue}
              selectedInvoices={getSelectedInvoiceObjects()}
              onBookingSuccess={handleBookingSuccess}
            />
          )}
          <Scrollbar>
            <TableContainer sx={{ minWidth: 1000 }} style={{ display: 'block', minHeight: '500px' }}>
              <Table className="invoice-details">
                <ListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={invoices.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                  hideCheckboxColumnHeader={hideCheckboxColumn}
                />
                <TableBody>
                  {filteredInvoices?.map((row, tableIndexs) => {
                    const {
                      id,
                      invoiceNumber,
                      amount,
                      amountIncVat,
                      isActive,
                      createdDate,
                      customerName,
                      invoiceStatus,
                      expressPayout,
                      isPfdAttached,
                      invoiceSalaryStatus,
                      invoiceToolVersion,
                      dueDate,
                      multipleFreelancer,
                      notes,
                      currency,
                      customer,
                      customerId,
                      isSalaryCreated,
                      invoiceType,
                      rutDeduction,
                      rotDeduction,
                      isAuthorizedForReminder,
                      isReminderInvoice,
                      IsDeleted,
                      IsActive,
                      ocrNumber,
                      isBooked,
                      fortnoxInvoiceNumber,
                      creditOriginInvoiceNumber
                    } = row;

                    const isItemSelected = selected.indexOf(id) !== -1;
                    const paymentTerm = customer?.customerAddress?.[0]?.paymentTerm || customer?.paymentTerm;
                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                        style={{ backgroundColor: getBackgroundColor(row, selectedTabValue) }}
                      >
                        {!hideCheckboxColumn && (
                          <TableCell padding="checkbox">
                            <Checkbox
                              checked={isItemSelected}
                              onChange={(event) => handleSingleSelectClick(event, id, invoiceNumber)}
                              size="small"
                            />
                          </TableCell>
                        )}

                        <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {invoiceNumber}
                        </TableCell>
                        {selectedTabValue === '6' && (
                           <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {fortnoxInvoiceNumber ? fortnoxInvoiceNumber : 'N/A'}
                        </TableCell>)}

                            {selectedTabValue === '6' && (
                           <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {creditOriginInvoiceNumber ? creditOriginInvoiceNumber : 'N/A'}
                        </TableCell>)}
                       

                        <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {ocrNumber}
                        </TableCell>

                        <TableCell align="left" style={{ fontSize: '13px', padding: '6px', whiteSpace: 'nowrap' }}>
                          {invoiceType === 2 ? 'E-invoice' : invoiceType === 3 ? 'Post' : 'Email'}
                        </TableCell>

                        {customerName?.length >= 9 ? (
                          <Tooltip title={customerName} arrow placement="top">
                            <>
                              <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                                {customerName?.substring(0, 9).concat('...')}
                              </TableCell>
                            </>
                          </Tooltip>
                        ) : (
                          <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                            {customerName}
                          </TableCell>
                        )}
                        
                            {selectedTabValue === '6' && (
                           <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {customerId ? customerId : 'N/A'}
                        </TableCell>)}
                        
                         <TableCell align="left" style={{ fontSize: '12px', padding: '6px', whiteSpace: 'nowrap' }}>
                          {invoiceToolVersion}
                        </TableCell>

                        <TableCell align="left" style={{ fontSize: '12px', padding: '6px' }}>
                          {row?.createdBy}
                        </TableCell>

                        <TableCell align="left" style={{ fontSize: '12px', padding: '6px' }}>
                          {row?.userName}
                        </TableCell>

                        <TableCell align="left" style={{ fontSize: '12px', padding: '6px', whiteSpace: 'nowrap' }}>
                          {createdDate.split('T')[0]}
                        </TableCell>

                        <TableCell align="left" style={{ fontSize: '12px', padding: '6px', whiteSpace: 'nowrap' }}>
                          {dueDate && dueDate.split('T')[0]}
                        </TableCell>
                        

                       <TableCell align="left" style={{ fontSize: '12px', padding: '6px', whiteSpace: 'nowrap',
    alignItems: 'center',
    gap: '4px'
}}
>
  {new Intl.NumberFormat('sv-SE').format(amountIncVat)} {currency}
</TableCell>


                        {selectedTabValue !== '6' && (
                        <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {invoiceStatus && (
                            <div variant="ghost">
                              {invoiceStatus === INVOICE_STATUS.UNPAID ? (
                                <span
                                  style={{
                                    cursor: row?.isSalaryStatusUpdatedManually || row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                                    backgroundColor: '#ffe2e1',
                                    padding: '5px 10px',
                                    borderRadius: '5px',
                                    color: '#B72136',
                                    fontSize: '0.75rem',
                                    fontWeight: '700',
                                    opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    !row?.isSalaryStatusUpdatedManually && row?.isActive && !row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3 &&
                                      setIstogglePaidUnpaid({
                                        id,
                                        show: true,
                                        type: 'paid',
                                        invoiceNumber,
                                      });
                                  }}
                                  isDisabled={row?.isHaveCreditInvoice || row?.isSalaryStatusUpdatedManually}
                                >
                                  Unpaid
                                </span>
                              ) : invoiceStatus === INVOICE_STATUS.PAID ? (
                                <span
                                  style={{
                                    cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                                    backgroundColor: 'rgba(53, 140, 118, 0.16)',
                                    padding: '5px 10px',
                                    borderRadius: '5px',
                                    color: 'rgb(37, 98, 82)',
                                    fontSize: '0.75rem',
                                    fontWeight: '700',
                                    opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    row?.isActive && !row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3 &&
                                      setIstogglePaidUnpaid({
                                        id,
                                        show: true,
                                        type: 'unpaid',
                                        invoiceNumber,
                                      });
                                  }}
                                  isDisabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                >
                                  {'Paid'}
                                </span>
                              ) : (
                                <span
                                  className="invoice_clr"
                                  style={{
                                    background: '#E1BEE7',
                                    padding: '5px 10px',
                                    borderRadius: '5px',
                                    color: '#6A1B9A',
                                    fontSize: '0.75rem',
                                    fontWeight: '700',
                                  }}
                                >
                                  Partial
                                </span>
                              )}
                            </div>
                          )}
                        </TableCell>)}

                         {selectedTabValue !== '6' && (
                        <TableCell align="left" style={{ fontSize: '13px', padding: '6px' }}>
                          {invoiceSalaryStatus && (
                            <Label variant="ghost"
                              color={
                                invoiceSalaryStatus === 1 && isSalaryCreated === true && isActive
                                  ? 'success'
                                  : invoiceSalaryStatus === 1
                                    ? 'error'
                                    : 'success'
                              }

                            >
                              {invoiceSalaryStatus === 1 ? (
                                <span
                                  style={{
                                    cursor:
                                      isSalaryCreated === true && isActive && invoiceSalaryStatus === 1 || row?.isHaveCreditInvoice || row?.invoicePurposeType === 3
                                        ? 'not-allowed'
                                        : 'pointer',
                                    opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    {
                                      isSalaryCreated === true && isActive && invoiceSalaryStatus === 1 || row?.invoicePurposeType === 3 || row?.isHaveCreditInvoice ? null : setCreateAccountModal({
                                        id,
                                        invoiceNumber,
                                        show: true,
                                        type: 'create',
                                        dueDate: '',
                                      });
                                    }

                                  }}
                                  isDisabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                >
                                  {isSalaryCreated === true && isActive && invoiceSalaryStatus === 1
                                    ? 'Created'
                                    : 'Unpaid'}
                                </span>
                              ) : (
                                sentenceCase(invoiceSalaryStatus === 2 ? 'Salary Paid' : 'Partial')
                              )}
                            </Label>
                          )}
                        </TableCell>)}

                         {selectedTabValue !== '6' && (
                        <TableCell align="center" style={{ fontSize: '13px', padding: '6px' }}>
                          <input
                            disabled={paymentTerm === '45' || paymentTerm === '60' || row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                            type="checkbox"
                            checked={expressPayout}
                            onChange={(event) => handleExpressPayoutChange(event, id, invoiceNumber)}
                          />
                        </TableCell>)}

                        
                        <TableCell
                          align="left"
                          style={{
                            marginTop: '-10px',
                            fontSize: '12px',
                            padding: '6px',
                          }}
                        >
                          {!multipleFreelancer ? (
                            <Tooltip title="Salary Details">
                              <>
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    
                                      handleGetSalary(id, false, invoiceNumber);
                                    
                                  }}
                                  style={{
                                    fontSize: '12px',
                                    padding: '6px',
                                    width: 96,
                                    opacity:  row?.invoicePurposeType === 3 && selectedTabValue === '8' ? 0.5 : 1,
                                    cursor:  row?.invoicePurposeType === 3 && selectedTabValue === '8' ? 'not-allowed' : 'pointer'
                                  }}
                                  disabled={ row?.invoicePurposeType === 3 && selectedTabValue === '8'}
                                >
                                  Salary Details
                                </Button>
                              </>
                            </Tooltip>
                          ) : (
                            <>
                              <FormControl 
                                sx={{ 
                                  m: 1, 
                                  minWidth: 110, 
                                  margin: 0,
                                  opacity: row?.invoicePurposeType === 3 && selectedTabValue === '8' ? 0.5 : 1,
                                  cursor: row?.invoicePurposeType === 3 && selectedTabValue === '8' ? 'not-allowed' : 'pointer'
                                }} 
                                variant="standard"
                              >
                                <InputLabel id="multi-freelancer-label" style={{ fontSize: '13px' }}>
                                  Salary Details
                                </InputLabel>
                                <Select
                                  defaultValue="choose"
                                  labelId="multi-freelancer-label"
                                  value={(tableIndexs === isOpenModal.index && freelancerName) || ''}
                                  label="Salary Details"
                                  disabled={row?.invoicePurposeType === 3 && selectedTabValue === '8'}
                                  onOpen={() => {
                                    handleGetSalary(id, true, invoiceNumber);
                                  }}
                                  onChange={(event) => handleChangeSalaryDropdown(event, tableIndexs)}
                                >
                                  {loading ? (
                                    <MenuItem value="">Loading...</MenuItem>
                                  ) : (
                                    selectedRow?.salaryFreelancer?.map((freelancer) => {
                                      const { userName, userId } = freelancer;

                                      return (
                                        <MenuItem
                                          key={userId}
                                          value={userName}
                                          onClick={() => {
                                            handleOpenFreelancerModal(freelancer, selectedRow?.createdDate, userId, freelancer.workingHours[0].invoiceId,selectedRow);
                                            loadAdditionalInvoiceServiceFee(invoiceNumber, freelancer);
                                          }}
                                          className={
                                            selectedRow.salaryFreelancer.find(
                                              (item) => item.userId === selectedRow.createdBy
                                            )?.userId === userId
                                              ? 'highlight-user'
                                              : ''
                                          }
                                        >
                                          {userName}
                                        </MenuItem>
                                      );
                                    })
                                  )}
                                </Select>
                              </FormControl>
                            </>
                          )}
                        </TableCell>

                         {selectedTabValue !== '6' ? (
                        <TableCell
                          align="right"
                          style={{
                            display: 'flex',
                            gap: '10px',
                            flexDirection: 'row',
                            alignItems: 'center',
                            padding: '6px',
                            textAlign: 'center',
                          }}
                        >
                          
                          {rutDeduction === true || rotDeduction === true ? (
                            <Tooltip title={rutDeduction ? 'RUT' : 'ROT'}>
                              <HomeIcon
                                style={{
                                  color: '#62b5e5',
                                  fontSize: 37,
                                  width: '40px',
                                  padding: 0,
                                }}
                              />{' '}
                            </Tooltip>
                          ) : (
                            <div style={{ padding: '10px 21px' }}></div>
                          )}
                          
                          
                          {row?.isEmailSent === true ? (
                            <EmailHistory invoiceId={row.id} fetchInvoices={fetchInvoices} >
                              <EmailIcon
                                style={{
                                  color: '#62b5e5',
                                  fontSize: 37,
                                  width: '40px',
                                  padding: 0,
                                  cursor: 'pointer'
                                }}
                              />
                            </EmailHistory>
                          ) : (
                            <div style={{ padding: '10px 21px' }}></div>
                          )}
                          <div>
                            {isPfdAttached && (
                              <Tooltip title="PDF">
                                <PictureAsPdfIcon
                                  variant="contained"
                                  color="error"
                                  style={{
                                    background: '#62b5e5',
                                    width: 28,
                                    minWidth: '28px',
                                    fontSize: '28px',
                                  }}
                                  onClick={() => {
                                    downloadPDF(invoiceNumber);
                                  }}
                                  sx={{
                                    ml: 1,
                                    color: '#fff',
                                    cursor: 'pointer',
                                  }}
                                />
                              </Tooltip>
                            )}
                            <div style={{ padding: '0px 21px ' }}> </div>
                          </div>

                          <div
                            onClick={() => {
                              if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                addnoteToggle(id);
                                setSelectedInvoiceNumber(invoiceNumber);
                              }
                            }}
                            style={{
                              cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                              opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                            }}
                          >
                            <Tooltip title="Notes">
                              <Button disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}>
                                <NoteIcon style={{ color: notes && 'rgb(226,204,97)', fontSize: '40px' }}>
                                  NoteIcon
                                </NoteIcon>
                              </Button>
                            </Tooltip>
                          </div>
                          <TableCell style={{ fontSize: '13px', padding: '6px' }}>
                            <DropdownButton
                              id="dropdown-basic-button"
                              title=""
                              className="action-dropdown"
                              style={{ gap: '15px' }}
                            >
                              <div
                                className="invoice_active_hover"
                                style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  gap: '10px', 
                                  cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                                  opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                                }}
                                onClick={() => {
                                  if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                    handleEditInvoice(invoiceNumber, row);
                                  }
                                }}
                              >
                                <Button
                                  style={{
                                    fontSize: '12px',
                                  }}
                                  disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                >
                                  <ModeEdit style={{ fontSize: '20px' }}></ModeEdit>
                                  <p
                                    className="mx-3"
                                    style={{
                                      marginBottom: '0px',
                                      color: 'black',
                                      fontSize: '13px',
                                      fontWeight: 'lighter',
                                    }}
                                  >
                                    {' '}
                                    Edit{' '}
                                  </p>
                                </Button>
                              </div>
                              {(isSalaryCreated === false) &&(
                                 <div
                                className="invoice_active_hover"
                                style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  gap: '10px', 
                                  cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                                  opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                                }}
                                onClick={() => {
                                  if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                    handleOpenCreditNoteModal(invoiceNumber, amountIncVat);
                                  }
                                }}
                              >
                                <Button
                                  style={{
                                    fontSize: '12px',
                                  }}
                                  disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                >
                                  <FaCreditCard style={{ fontSize: '20px' }}></FaCreditCard>
                                  <p
                                    className="mx-3"
                                    style={{
                                      marginBottom: '0px',
                                      color: 'black',
                                      fontSize: '13px',
                                      fontWeight: 'lighter',
                                    }}
                                  >
                                    Credit Note
                                  </p>
                                </Button>
                              </div>)}
                                {/* Reuseable code for View Edits do not remove this code */}
                              <div
                                className="invoice_active_hover"
                                style={{ 
                                  display: 'flex', 
                                  alignItems: 'center', 
                                  gap: '10px', 
                                  cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                                  opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3 ? 0.5 : 1
                                }}
                                onClick={() => {
                                  if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                    handleOpenEditModal(invoiceNumber);
                                  }
                                }}
                              >
                                <Button
                                  style={{
                                    fontSize: '12px',
                                  }}
                                  disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                >
                                  <MdEditSquare style={{ fontSize: '20px' }}></MdEditSquare>
                                  <p
                                    className="mx-3"
                                    style={{
                                      marginBottom: '0px',
                                      color: 'black',
                                      fontSize: '13px',
                                      fontWeight: 'lighter',
                                    }}
                                  >
                                    View Edits
                                  </p>
                                </Button>
                              </div> 
                              {/* {invoiceStatus === 2 ? null : (
                                <div
                                  className="invoice_active_hover"
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '10px',
                                    cursor: isAuthorizedForReminder ? 'not-allowed' : 'pointer',
                                  }}
                                  onClick={() => {
                                    if (
                                      !isAuthorizedForReminder &&
                                      !isReminderInvoice &&
                                      isActive &&
                                      invoiceStatus == 1
                                    ) {
                                      setCreateAccountModal({
                                        id,
                                        invoiceNumber,
                                        show: true,
                                        type: 'reminder',
                                        dueDate,
                                      });
                                    }
                                  }}
                                >
                                  <Button style={{ fontSize: '12px' }} disabled={isAuthorizedForReminder}>
                                    <NotificationAdd style={{ fontSize: '20px' }} />
                                    <p
                                      className="mx-3"
                                      style={{
                                        marginBottom: '0px',
                                        color: 'black',
                                        fontSize: '13px',
                                        fontWeight: 'lighter',
                                      }}
                                    >
                                      Reminder
                                    </p>
                                  </Button>
                                </div>
                              )} */}
                              <div>
                                {(isSalaryCreated === true && isActive && invoiceSalaryStatus === 1 && (
                                  <div
                                    className="invoice_active_hover"
                                    style={{ display: 'flex', alignItems: 'center', gap: '0px', cursor: 'pointer' }}
                                    onClick={() => {
                                      setCreateAccountModal({
                                        id,
                                        invoiceNumber,
                                        show: true,
                                        type: 'undo',
                                        dueDate: '',
                                      });
                                    }}
                                  >
                                    <Button
                                      style={{
                                        fontSize: '12px',
                                      }}
                                    >
                                      <UndoSharpIcon
                                        color={'error'}
                                        style={{ width: 20, minWidth: '20px', color: 'rgb(195,65,82)' }}
                                        sx={{
                                          fontSize: '12px',
                                        }}
                                      >
                                        {sentenceCase('Undo')}
                                      </UndoSharpIcon>
                                      <p
                                        className="mx-3"
                                        style={{
                                          marginBottom: '0px',
                                          color: 'black',
                                          fontSize: '13px',
                                          fontWeight: 'lighter',
                                        }}
                                      >
                                        Undo Salary
                                      </p>
                                    </Button>
                                  </div>
                                )) ||
                                  (isSalaryCreated === true && !isActive && (
                                    <div className="invoice_active_hover"
                                      style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                      <Button
                                        style={{ fontSize: '12px' }}
                                      >
                                        <CheckCircleIcon style={{ color: 'rgb(37, 98, 82)', fontSize: '20px' }} />
                                        <p
                                          className="mx-3"
                                          style={{
                                            marginBottom: '0px',
                                            color: 'black',
                                            fontSize: '13px',
                                            fontWeight: 'lighter',
                                          }}
                                        >
                                          {' '}
                                        </p>
                                      </Button>
                                    </div>
                                  )) || (

                                    <>
                                    {selectedTabValue === "5" ? "" :
                                      
                                      <div>
                                        {isSalaryCreated === false && (
                                        <div>
                                          {invoiceSalaryStatus === 1 && (row.isSalaryStatusUpdatedManually === false || row.isSalaryStatusUpdatedManually === true) && row.isHaveCreditInvoice === false && (
                                            <div
                                              className="invoice_active_hover"
                                              style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 'not-allowed' : 'pointer',
                                                opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 0.5 : 1
                                              }}
                                              onClick={() => {
                                                if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                                  setisChangeStatus({
                                                    id,
                                                    show: true,
                                                    type: 'paid',
                                                    invoiceNumber,
                                                  });
                                                }
                                              }}
                                            >
                                              <Button
                                                style={{
                                                  fontSize: '12px',
                                                }}
                                                disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                              >
                                                <CreditScoreIcon
                                                  style={{ color: '#62b5e5', fontSize: '20px' }}
                                                ></CreditScoreIcon>
                                                <p
                                                  className="mx-3"
                                                  style={{
                                                    marginBottom: '0px',
                                                    color: 'black',
                                                    fontSize: '13px',
                                                    fontWeight: 'lighter',
                                                  }}
                                                >
                                                  Manually Paid
                                                </p>
                                              </Button>
                                            </div>)}

                                          {invoiceSalaryStatus === 2 && row.isSalaryStatusUpdatedManually === true && row.isHaveCreditInvoice === false &&(
                                            <div
                                              className="invoice_active_hover"
                                              style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 'not-allowed' : 'pointer',
                                                opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 0.5 : 1
                                              }}
                                              onClick={() => {
                                                if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                                  setisChangeStatus({
                                                    id,
                                                    show: true,
                                                    type: 'Unpaid',
                                                    invoiceNumber,
                                                  });
                                                }
                                              }}
                                            >
                                              <Button
                                                style={{
                                                  fontSize: '12px',
                                                }}
                                                disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                              >
                                                <CreditCardOffIcon
                                                  style={{ color: '#62b5e5', fontSize: '20px' }}
                                                ></CreditCardOffIcon>
                                                <p
                                                  className="mx-3"
                                                  style={{
                                                    marginBottom: '0px',
                                                    color: 'black',
                                                    fontSize: '13px',
                                                    fontWeight: 'lighter',
                                                  }}
                                                >
                                                  Mark UnPaid
                                                </p>
                                              </Button>
                                            </div>)}

                                        </div>)}
                                      </div>
                                      }
                                      
                                      {selectedTabValue === "5" ? "" :
                                      <div>
                                       {invoiceSalaryStatus === 1 && (row.isSalaryStatusUpdatedManually === false || row.isSalaryStatusUpdatedManually === true) && (
                                        <div
                                          className="invoice_active_hover"
                                          style={{ 
                                            display: 'flex', 
                                            alignItems: 'center', 
                                            gap: '10px', 
                                            cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 'not-allowed' : 'pointer',
                                            opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 0.5 : 1
                                          }}
                                          onClick={() => {
                                            if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                              setCreateAccountModal({
                                                id,
                                                invoiceNumber,
                                                show: true,
                                                type: 'create',
                                                dueDate: '',
                                              });
                                            }
                                          }}
                                          disabled={row?.isSalaryStatusUpdatedManually || row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                        >
                                          <Button style={{ fontSize: '12px', minWidth: '50px' }} disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}>
                                            <NoteAddIcon style={{ color: '#62b5e5', fontSize: '20px' }}>Create</NoteAddIcon>
                                            <p
                                              className="mx-3"
                                              style={{
                                                marginBottom: '0px',
                                                color: 'black',
                                                fontSize: '13px',
                                                fontWeight: 'lighter',
                                              }}
                                            >
                                              {' '}
                                              Create Salary
                                            </p>
                                          </Button>
                                        </div>)}</div>
                                      }
                                       
                                    </>

                                  )}

                                {!isActive && (
                                  <div
                                    className="invoice_active_hover"
                                    style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                                    onClick={() => {
                                      settoggleIsActive({ id, invoiceNumber, show: true });
                                    }}
                                  >
                                    <Button
                                      value={'false'}
                                      style={{
                                        fontSize: '12px',
                                      }}
                                    >
                                      <AddCircleOutlineIcon style={{ fontSize: '20px' }} />
                                      <p
                                        className="mx-3"
                                        style={{
                                          marginBottom: '0px',
                                          color: 'black',
                                          fontSize: '13px',
                                          fontWeight: 'lighter',
                                        }}
                                      >
                                        {' '}
                                        Activate
                                      </p>
                                    </Button>
                                  </div>
                                )}

                                {isActive ? (
                                  <div
                                    className="invoice_active_hover"
                                    style={{ 
                                      display: 'flex', 
                                      alignItems: 'center', 
                                      gap: '10px', 
                                      cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 'not-allowed' : 'pointer',
                                      opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 0.5 : 1
                                    }}
                                    onClick={() => {
                                      if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3) {
                                        setActivateModal({ id, invoiceNumber, show: true });
                                      }
                                    }}
                                  >
                                    <Button
                                      style={{
                                        fontSize: '12px',
                                      }}
                                      disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                    >
                                      <RemoveCircleIcon
                                        color={'error'}
                                        value={'false'}
                                        style={{
                                          color: 'rgb(195,65,82)',
                                          width: 25,
                                          minWidth: '30px',
                                          fontSize: '20px',
                                          justifyContent: 'left',
                                          marginLeft: '-4px',
                                        }}
                                      ></RemoveCircleIcon>
                                      <p
                                        className="mx-2"
                                        style={{
                                          marginBottom: '0px',
                                          color: 'black',
                                          fontSize: '13px',
                                          fontWeight: 'lighter',
                                        }}
                                      >
                                        {' '}
                                        Deactivate
                                      </p>
                                    </Button>
                                  </div>
                                ) : (
                                  <div className="invoice_active_hover"
                                    style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <Button
                                      style={{
                                        fontSize: '12px',
                                        cursor: 'not-allowed',
                                      }}
                                      disabled
                                    >
                                      <CancelIcon style={{ fontSize: '20px' }} />
                                      <p
                                        className="mx-3"
                                        style={{
                                          marginBottom: '0px',
                                          color: 'black',
                                          fontSize: '13px',
                                          fontWeight: 'lighter',
                                        }}
                                      >
                                        Cancelled
                                      </p>
                                    </Button></div>
                                )}
                              </div>
                              <div
                                className="invoice_active_hover"
                                style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                                onClick={() => {
                                  // Mark that user is navigating away from invoice tabs
                                  // and preserve search state for view-logs
                                  dispatch(setNavigatedAway(true));
                                  dispatch(setPreserveSearch(true));
                                  navigate(`/dashboard/view-logs?type=invoice&id=${invoiceNumber}`, {
                                    state: {
                                      type: 'name',
                                      name: row?.userName,
                                    },
                                  });
                                }}
                              >
                                <Button
                                  type="submit"
                                  style={{
                                    fontSize: '12px',
                                  }}
                                >
                                  <HistoryIcon style={{ fontSize: '20px' }}></HistoryIcon>
                                  <p
                                    className="mx-3"
                                    style={{
                                      marginBottom: '0px',
                                      color: 'black',
                                      fontSize: '13px',
                                      fontWeight: 'lighter',
                                    }}
                                  >
                                    {' '}
                                    View Logs
                                  </p>
                                </Button>
                              </div>
                              {isActive && (
                                <div
                                  className="invoice_active_hover"
                                  style={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    gap: '10px', 
                                    cursor: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 'not-allowed' : 'pointer',
                                    opacity: row?.isHaveCreditInvoice || row?.invoicePurposeType === 3? 0.5 : 1
                                  }}
                                  onClick={() => {
                                    if (!row?.isHaveCreditInvoice && row?.invoicePurposeType !== 3 ) {
                                      setCreateAccountModal({
                                        id,
                                        invoiceNumber,
                                        show: true,
                                        type: 'cancel',
                                        dueDate: '',
                                      });
                                    }
                                  }}
                                >
                                  <Button
                                    disableRipple
                                    disableFocusRipple
                                    style={{
                                      fontSize: '12px',
                                    }}
                                    disabled={row?.isHaveCreditInvoice || row?.invoicePurposeType === 3}
                                  >
                                    <HighlightOff style={{ color: 'rgb(195,65,82)', fontSize: '20px' }}>
                                      Cancel
                                    </HighlightOff>
                                    <p
                                      className="mx-3"
                                      style={{
                                        marginBottom: '0px',
                                        color: 'black',
                                        fontSize: '13px',
                                        fontWeight: 'lighter',
                                      }}
                                    >
                                      Cancel
                                    </p>
                                  </Button>
                                </div>
                              )}
                            </DropdownButton>
                          </TableCell>

                        </TableCell>):
                        (
                            <TableCell
                          align="left"
                          style={{
                            marginTop: '-10px',
                            fontSize: '12px',
                            padding: '6px',
                          }}
                        >

                          <Tooltip title="Credit Details">
                              <>
                                <Button
                                  variant="outlined"
                                 
                                  style={{
                                    fontSize: '12px',
                                    padding: '6px',
                                    width: 96,
                                  }}
                                  onClick={() => handleOpenCreditDetailsModal(row.invoiceNumber)}
                                >
                                  Credit Details
                                </Button>
                              </>
                            </Tooltip>

                          </TableCell>
                        )
                        
                      }
                      </TableRow>
                    );
                  })}
                </TableBody>

                <CreditNoteModal
                  open={isCreditNoteModalOpen}
                  onClose={handleCloseCreditNoteModal}
                  invoiceNumber={selectedInvoice.invoiceNumber}
                  amount={selectedInvoice.amount}
                  fetchInvoices={fetchInvoices}
                />

                <Modal
                  open={isOpenModal.open}
                  onClose={handleCloseModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box
                    sx={{
                      ...style,
                      width: '70%',
                      maxWidth: '70%',
                      margin: '0 auto',
                      height: '80vh',
                      overflowY: 'scroll',
                    }}
                    ref={handleModalRef}
                  >
                    <Box sx={{ height: 'fit-content' }} id="salary-modal">
                      <Typography id="modal-modal-title" variant="h6" component="h2">
                        Salary Details <br />
                        User Id: #{selectedRow?.userId ? selectedRow?.userId : selectedRow?.createdBy}
                        <br />
                        Invoice Number: #{selectedRow?.invoiceNumber}
                        <br />
                        User Name: {selectedRow?.userName}
                        <br />
                        User SNN/DOB: {selectedRow?.freelancerSSN_DOB ? selectedRow?.freelancerSSN_DOB : selectedRow?.userSSN_DOB}
                        {(selectedRow?.isSsnExist === true ||
                          selectedRow?.isFreelancerSsnExist === true) && (
                            <>
                              {(selectedRow?.isFreelancerSsnValid !== undefined
                                ? selectedRow?.isFreelancerSsnValid
                                : selectedRow?.isSsnValid) === true ? (
                                <VerifiedIcon
                                  style={{
                                    color: '#4caf50',
                                    marginLeft: '8px',
                                    fontSize: '20px',
                                    verticalAlign: 'middle'
                                  }}
                                  titleAccess="SSN Verified"
                                />
                              ) : (selectedRow?.isFreelancerSsnValid !== undefined
                                ? selectedRow?.isFreelancerSsnValid
                                : selectedRow?.isSsnValid) === false ? (
                                <>
                                  <WarningIcon
                                    style={{
                                      color: '#ff9800',
                                      marginLeft: '8px',
                                      fontSize: '20px',
                                      verticalAlign: 'middle'
                                    }}
                                    titleAccess="Unverified"
                                  />
                                  <Button
                                    variant="outlined"
                                    disabled
                                    style={{
                                      marginLeft: '8px',
                                      fontSize: '11px',
                                      padding: '2px 8px',
                                      cursor: 'not-allowed',
                                      opacity: 0.6
                                    }}
                                  >
                                    Verify SSN
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    const userId = selectedRow?.userId ? selectedRow?.userId : selectedRow?.createdBy;
                                    window.open(`/dashboard/users/${userId}`, '_blank');
                                  }}
                                  style={{
                                    marginLeft: '8px',
                                    fontSize: '11px',
                                    padding: '2px 8px',
                                  }}
                                >
                                  Verify SSN
                                </Button>
                              )}
                            </>
                          )}
                        <br />
                         Country: {selectedRow?.customer?.country || 'N/A'}
                        <br />
                         Invoice Type: {selectedRow?.invoiceType == 2 ? 'E-Invoice' : selectedRow?.invoiceType == 3 ? 'Post' : 'Email'}
                        <br />
                        Created By: {selectedRow?.createdByEmail}
                        <Tooltip
                          title={tooltipTitle} // Dynamically set the tooltip title
                          onClose={() => setTooltipTitle('Copy Email')} // Reset title when tooltip closes
                          leaveDelay={500}
                        >
                          <ContentCopyIcon
                            style={{ cursor: 'pointer', marginLeft: '8px' }}
                            onClick={() => {
                              if (selectedRow?.createdByEmail) {
                                if (!document.hasFocus()) {
                                  setTooltipTitle('Cannot copy, Please try again');
                                  return;
                                }

                                navigator.clipboard.writeText(selectedRow.createdByEmail);
                                setTooltipTitle('Copied');
                              }
                            }}
                          />
                        </Tooltip>
                        <br />
                        {selectedRow?.customer?.name ? 'Customer Name:' : ''} {selectedRow?.customer?.name || ''}
                        {selectedRow?.customer?.name && (
                          selectedRow?.customer?.isCustomerUploadedToComplyCube ? (
                            <VerifiedIcon 
                              style={{ 
                                color: '#4caf50', 
                                marginLeft: '8px', 
                                fontSize: '20px',
                                verticalAlign: 'middle'
                              }} 
                              titleAccess="Verified on ComplyCube"
                            />
                          ) : (
                            <Button
                              size="small"
                              variant="outlined"
                              style={{ 
                                marginLeft: '8px',
                                fontSize: '11px',
                                padding: '2px 8px',
                                textTransform: 'none'
                              }}
                              onClick={() => handleCustomerComplyCube(selectedRow?.customer?.customerId)}
                            >
                              Upload to ComplyCube
                            </Button>
                          )
                        )}
                        <br />
                        {selectedRow?.customer?.orgNo === "" ?
                         <>
                         Customer SSN: {selectedRow?.customer?.ssn || '0'}
                            <>
                              {selectedRow?.customer?.isSsnValid === true ? (
                                <VerifiedIcon
                                  style={{
                                    color: '#4caf50',
                                    marginLeft: '8px',
                                    fontSize: '20px',
                                    verticalAlign: 'middle'
                                  }}
                                  titleAccess="SSN Verified"
                                />
                              )  
                                : selectedRow?.customer?.isSsnValid === false ? (
                                <>
                                  <WarningIcon
                                    style={{
                                      color: '#ff9800',
                                      marginLeft: '8px',
                                      fontSize: '20px',
                                      verticalAlign: 'middle'
                                    }}
                                    titleAccess="Unverified"
                                  />
                                  <Button
                                    variant="outlined"
                                    disabled
                                    style={{
                                      marginLeft: '8px',
                                      fontSize: '11px',
                                      padding: '2px 8px',
                                      cursor: 'not-allowed',
                                      opacity: 0.6
                                    }}
                                  >
                                    Verify SSN
                                  </Button>
                                </>
                              ) : (
                                <Button
                                  variant="outlined"
                                  onClick={() => {
                                    const customerId = selectedRow?.customer?.customerId || '';
                                    window.open(`/dashboard/customers/${customerId}`, '_blank');
                                  }}
                                  style={{
                                    marginLeft: '8px',
                                    fontSize: '11px',
                                    padding: '2px 8px',
                                  }}
                                >
                                  Verify SSN
                                </Button>
                              )}
                            </>
                         <br />
                         </> 
                         : (
                          <>
                            Organization Number: {selectedRow?.customer?.orgNo || 0}
                            <br />
                          </>
                        )}
                        {selectedRow?.customer?.email ? 'Customer Email:' : ''} {selectedRow?.customer?.email || ''}
                      </Typography>
                      <div>
                        <div style={{display: 'flex', margin: '10px 0'}}>
                          <b>Description: </b>
                          <span style={{marginLeft: '8px'}}> {selectedRow?.description || ''}</span>
                        </div>
                      </div>
                      <div>
                        <div
                          className="table-scroll"
                          style={{
                            overflow: 'auto', 
                            margin: '0 0 20px 0',
                          }}
                        >
                          <Table className="salary-details">
                            <ListHead
                              headLabel={WORKING_HOURS_TABLE_HEAD}
                              onRequestSort={handleRequestSort}
                              onSelectAllClick={handleSelectAllClick}
                              hideCheckboxColumnHeader={true} 
                            />
                            <TableBody>
                              {selectedRow?.workingHours?.map((row, i) => {
                                const {
                                  number,
                                  expressFee,
                                  workingDate,
                                  articleName,
                                  totalAmount,
                                  grossAmount,
                                  amountPerUnit,
                                  isArticleShownInInvoice,
                                  vat,
                                  bookkeepingArticleNumber,
                                  distance,
                                  country,
                                  allowanceDestination,
                                  reasonForTrip,
                                  carRegistrationNo,
                                  tripStartedDate,
                                  tripEndedDate,
                                  tripStartedPlace,
                                  foodAllowance,
                                } = row;
                                return (
                                  <TableRow hover key={i} tabIndex={-1}>
                                    <TableCell align="left" style={{ padding: '6px 16px' }} scope="row">
                                      {workingDate !== '0001-01-01T00:00:00' ? formatDate2(workingDate) : '-'}
                                    </TableCell>

                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {articleName}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {isArticleShownInInvoice ? 'Yes' : 'No'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {formatNumber(vat)}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {(bookkeepingArticleNumber)}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {formatNumber(number)}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {formatNumber(amountPerUnit)}
                                   </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {formatNumber(totalAmount)}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {formatNumber(grossAmount)}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px', whiteSpace: 'nowrap' }}>
                                      {formatNumber(expressFee)}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {distance || '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {carRegistrationNo || '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {tripStartedPlace || '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {tripStartedDate ? formatDate2(tripStartedDate) : '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {tripEndedDate ? formatDate2(tripEndedDate) : '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {reasonForTrip || '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {country || '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {allowanceDestination || '-'}
                                    </TableCell>
                                    <TableCell align="left" style={{ padding: '6px 16px' }}>
                                      {foodAllowance ? `${foodAllowance.toFixed(2)} SEK` : '-'}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                            </TableBody>
                          </Table>
                        </div>
                        {selectedRow?.workingHours?.length && (
                          <Table>
                            <TableBody>
                              {(!selectedRow?.isFixed && selectedRow?.totalHourlyWagesHours > 0) && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Total Hours
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalHourlyWagesHours)}
                                  </TableCell>
                                </TableRow>
                              )}
                              {(!selectedRow?.isFixed && selectedRow?.hourlyWagesAmountPerUnit > 0) && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Total Hours Per Unit Amount
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.hourlyWagesAmountPerUnit)}
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.vatAmount > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Amount INC. VAT
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.vatAmount)} {selectedRow?.currency}
                                  </TableCell>
                                </TableRow>
                              )}  

                              <TableRow>
                                <TableCell
                                  style={{ padding: '7px 10px' }}
                                  align="left"
                                  colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    VAT% {selectedRow?.isReverseVatApplied ? `(${selectedRow?.reverseVatType})` : ""}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.vat}
                                  </TableCell>
                                </TableRow>                           

                              {(!selectedRow?.isFixed && selectedRow?.amount > 0) && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Invoice Amount
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {!selectedRow?.isFixed ? formatNumber(selectedRow?.amount) : 0} {selectedRow?.currency}
                                  </TableCell>
                                </TableRow>
                              )}

                              {(selectedRow?.isFixed && selectedRow?.amount > 0) && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Fixed Price
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.amount)}{' '}
                                    {selectedRow?.currency}
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.currency !== "SEK" ? (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Amount In SEK EX. VAT
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.amountInSEK)} SEK
                                  </TableCell>
                                </TableRow>) : " "}
                              {selectedRow?.expressPayout ? (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Express Payout Fee
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.multipleFreelancer === false
                                      ? formatNumber(selectedRow?.expressPayoutAmount) || '0'
                                      : formatNumber(selectedRow?.expressPayoutAmount) || '0'}{' '}
                                    SEK
                                  </TableCell>
                                </TableRow>
                              ) : (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Invozio Fee ({formatNumber(selectedRow?.feePercentage)}%)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                      display: 'flex',
                                      justifyContent: 'flex-end',
                                      alignItems: 'center',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.multipleFreelancer === false
                                      ? formatNumber(selectedRow?.fakturaNuFee) || '0'
                                      : formatNumber(selectedRow?.fakturaFee) || '0'}{' '}
                                    SEK
                                    {selectedTabValue !== '3' &&
                                      (
                                        (selectedRow?.multipleFreelancer === false
                                          ? selectedRow?.fakturaNuFee > 0
                                          : selectedRow?.fakturaFee > 0)
                                      ) && (
                                        <IconButton
                                          onClick={() => handleRemoveInvozioFee(selectedRow, selectedRowInvoiceNumber)}
                                          color="error"
                                          size="small"
                                          sx={{ ml: 1 }}
                                          title="Remove Fee"
                                        >
                                          <DeleteIcon fontSize="small" />
                                        </IconButton>
                                      )
                                    }
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.totalPostFeeAmount > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Post Fee
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalPostFeeAmount)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.foreignBankFee > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Foreign Bank Fee
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.foreignBankFee)} SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.currency !== "SEK" ? (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Currency Margin Amount ({selectedRow?.currencyRate}%)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalCurrencyMargin)} SEK
                                  </TableCell>
                                </TableRow>) : " "}

                              {selectedRow?.pensionAmount > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Pension Amount
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.pensionAmount)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {(selectedRow?.totalSocialFee > 0 || selectedRow?.socialFee > 0) && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Social Fee  ({formatNumber(selectedRow?.socialFeePer) || formatNumber(selectedRow?.socialFeePer)}%)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalSocialFee) || formatNumber(selectedRow?.socialFee)} SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.totalPensionContribution > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Pension Social Fee ({formatNumber(selectedRow?.pensionFeePer)}%)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalPensionContribution)} SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.holidaySavingsAmount > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Holiday Pay Amount
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.holidaySavingsAmount)} SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {new Date(selectedRow.createdDate) <= new Date('2023-12-31T23:59:59') && selectedRow?.administratorFee > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Administrator Fee
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.administratorFee)}
                                  </TableCell>
                                </TableRow>
                              )}

                              {additionalInvoiceCharges.map((row) => (
                                <TableRow key={row.id}>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    <div style={{ display: 'flex', width: '65%' }}>
                                      <input
                                        type="text"
                                        value={row.reminderText}
                                        onChange={(e) => handleAdditionalChargeNoteChange(row.id, e.target.value)}
                                        placeholder={row.isDeduct ? 'Deduct Fee Note' : 'Add Fee Note'}
                                        disabled={!row.editing}
                                        style={{
                                          border: '0px solid black',
                                          borderBottom: row.editing ? '1px solid gray' : 'none',
                                          background: 'transparent',
                                          fontWeight: 'bold',
                                          outline: 'none',
                                          width: '100%',
                                          cursor: row.editing ? 'text' : 'default',
                                          color: '#212B36',
                                        }}
                                      />
                                      <Tooltip arrow title={'Check this if amount should be included after tax'}>
                                        <input
                                          type="checkbox"
                                          checked={row.isAfterTax || false} // Default unchecked
                                          onChange={(e) => handleCheckboxChange(row.id, e.target.checked)}
                                          disabled={!row.editing} // Disable when not in editing mode
                                          className="mx-1"
                                        />
                                      </Tooltip>

                                      {!row.editing && <span>{row.isDeduct ? '[Fee]' : '[Bonus]'}</span>}
                                      {/* Show CheckIcon only when editing and both fields are filled */}

                                      {row.showCheck && row.editing && (
                                        <CheckIcon
                                          style={{ color: '#13161a9e', cursor: 'pointer', marginLeft: '5px' }}
                                          onClick={() => {
                                            if (!isCheckIconDisabled) {
                                              submitAddEditAdditionalCharges(row.id, selectedRowInvoiceNumber);
                                            }
                                          }}
                                          disabled={isCheckIconDisabled} // Disable the CheckIcon
                                        />
                                      )}

                                      {/* Show EditIcon after confirming */}
                                      {!row.editing && (
                                        <ModeEditIcon
                                          style={{ color: '#13161a9e', cursor: 'pointer', marginLeft: '5px' }}
                                          onClick={() => handleEdit(row.id)}
                                        />
                                      )}

                                      {/* Show CancelIcon to remove the row */}
                                      <CancelIcon
                                        style={{ color: '#13161a9e', cursor: 'pointer', marginLeft: '5px' }}
                                        onClick={() => handleCancel(row.id, row)}
                                      />
                                    </div>
                                  </TableCell>

                                  {/* Editable Numeric Fee Field */}
                                  <TableCell
                                    style={{ padding: '7px 10px', textAlign: 'right', minWidth: 90 }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    <input
                                      type="text"
                                      value={
                                        row.editing
                                          ? row.feeValue // show the raw value while editing
                                          : row.feeValue != null && !isNaN(Number(row.feeValue))
                                            ? Number(row.feeValue).toFixed(2)
                                            : ''
                                      }
                                      onChange={(e) => handleFeeChange(row.id, e.target.value)}
                                      onBlur={(e) => handleFeeChange(row.id, formatToTwoDecimals(e.target.value))}
                                      placeholder="0.00"
                                      disabled={!row.editing}
                                      style={{
                                        border: '0px solid black',
                                        borderBottom: row.editing ? '1px solid gray' : 'none',
                                        background: 'transparent',
                                        fontWeight: '100',
                                        outline: 'none',
                                        width: '50px',
                                        textAlign: 'right',
                                        cursor: row.editing ? 'text' : 'default',
                                        color: '#212B36',
                                      }}
                                    />
                                    <span style={{ fontWeight: '100' }}> SEK</span>
                                  </TableCell>
                                </TableRow>
                              ))}

                              {selectedRow?.totalGrossAmount > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Total Gross Salary
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalGrossAmount)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.incomeTaxReductionInSek > 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Income Tax  ({formatNumber(selectedRow?.tax)}%)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.incomeTaxReductionInSek)} SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.totalAllowanceAbroadTaxFree !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance outside Sweden Tax Free
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalAllowanceAbroadTaxFree)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalAllowanceAbroadTaxable !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance outside Sweden Taxable
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {formatNumber(selectedRow?.totalAllowanceAbroadTaxable)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceHalfDayTaxFree !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Tax Free Half Day
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceHalfDayTaxFree?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceHalfDayTaxable !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Taxable Half Day
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceHalfDayTaxable?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceFullDayTaxFree !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Tax Free Full Day
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceFullDayTaxFree?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceFullDayTaxable !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Taxable Full Day
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceFullDayTaxable?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalMileageTaxFree !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Mileage Report Tax Free
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalMileageTaxFree?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalMileageTaxable !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Mileage Report Taxable
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalMileageTaxable?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.totalTravelCostsAccordingToAttachedPdfTaxFree !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Travel Expenses as per attached PDF Tax Free
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalTravelCostsAccordingToAttachedPdfTaxFree?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.taxfreeArticle !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Expenses for materials and tools as per attached PDF Tax Free
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.taxfreeArticle?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxable !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Expenses for materials and tools as per attached PDF Taxable
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxable?.toFixed(
                                      2
                                    )}{' '}
                                    SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalExpenditureForMaterialsAndToolsTaxable !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Expenses for materials and tools Taxable
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalExpenditureForMaterialsAndToolsTaxable?.toFixed(
                                      2
                                    )}{' '}
                                    SEK
                                  </TableCell>
                                </TableRow>
                              )}

                              {selectedRow?.totalAllowanceAbroadTaxFreeNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance outside Sweden Tax Free (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalAllowanceAbroadTaxFreeNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalAllowanceAbroadTaxableNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance outside Sweden Taxable (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalAllowanceAbroadTaxableNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceHalfDayTaxFreeNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Tax Free Half Day (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceHalfDayTaxFreeNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceHalfDayTaxableNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Taxable Half Day (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceHalfDayTaxableNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceFullDayTaxFreeNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Tax Free Full Day (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceFullDayTaxFreeNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalDomesticAllowanceFullDayTaxableNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Allowance in Sweden Taxable Full Day (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalDomesticAllowanceFullDayTaxableNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalMileageTaxFreeNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Mileage Report Tax Free (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalMileageTaxFreeNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalMileageTaxableNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Mileage Report Taxable (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalMileageTaxableNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalTravelCostsAccordingToAttachedPdfTaxFreeNotShown !== 0 && (
                                <TableRow>
                                  <TableCell
                                    style={{ padding: '7px 10px' }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3, fontWeight: 'bold' }}
                                  >
                                    Travel Expenses as per attached PDF Tax Free (Not Included)
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      padding: '7px 10px',
                                      textAlign: 'right',
                                    }}
                                    align="left"
                                    colSpan={6}
                                    sx={{ py: 3 }}
                                  >
                                    {selectedRow?.totalTravelCostsAccordingToAttachedPdfTaxFreeNotShown?.toFixed(2)} SEK
                                  </TableCell>
                                </TableRow>
                              )}
                              {selectedRow?.totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxFreeNotShown !==
                                0 && (
                                  <TableRow>
                                    <TableCell
                                      style={{ padding: '7px 10px' }}
                                      align="left"
                                      colSpan={6}
                                      sx={{ py: 3, fontWeight: 'bold' }}
                                    >
                                      Expenses for materials and tools as per attached PDF Tax Free (Not Included)
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        padding: '7px 10px',
                                        textAlign: 'right',
                                      }}
                                      align="left"
                                      colSpan={6}
                                      sx={{ py: 3 }}
                                    >
                                      {selectedRow?.totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxFreeNotShown?.toFixed(
                                        2
                                      )}{' '}
                                      SEK
                                    </TableCell>
                                  </TableRow>
                                )}
                              {selectedRow?.totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxableNotShown !==
                                0 && (
                                  <TableRow>
                                    <TableCell
                                      style={{ padding: '7px 10px' }}
                                      align="left"
                                      colSpan={6}
                                      sx={{ py: 3, fontWeight: 'bold' }}
                                    >
                                      Expenses for materials and tools as per attached PDF Taxable (Not Included)
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        padding: '7px 10px',
                                        textAlign: 'right',
                                      }}
                                      align="left"
                                      colSpan={6}
                                      sx={{ py: 3 }}
                                    >
                                      {selectedRow?.totalExpenditureForMaterialsAndToolsAccordingToAttachedPdfTaxableNotShown?.toFixed(
                                        2
                                      )}{' '}
                                      SEKs
                                    </TableCell>
                                  </TableRow>
                                )}

                              <TableRow>
                                <TableCell
                                  style={{ padding: '7px 10px' }}
                                  align="left"
                                  colSpan={6}
                                  sx={{ py: 3, fontWeight: 'bold' }}
                                >
                                  Total amount to be paid to bank
                                </TableCell>
                                <TableCell
                                  style={{
                                    padding: '7px 10px',
                                    textAlign: 'right',
                                    minWidth: 90,
                                  }}
                                  align="left"
                                  colSpan={6}
                                  sx={{ py: 3, fontWeight: 'bold' }}
                                >
                                  {formatNumber(selectedRow?.toPayAmont)} SEK
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        )}
                      </div>

                      <Button
                        variant="contained"
                        color="primary"
                        className="mt-3 mx-2"
                       style={{
                          cursor: selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                          color: 'white',
                          opacity: selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3 ? 0.5 : 1
                        }}
                        onClick={() => {
                          if (!(selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3)) {
                            addNewAdditionCharges(false); // Pass `true` for Add
                          }
                        }} // Pass `false` for Deduct
                        isDisabled={selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3}
                      >
                        <AddIcon style={{ padding: '0px' }} /> Add
                      </Button>

                      <Button
                        variant="contained"
                        color="primary"
                        className="mt-3 mx-2"
                       style={{
                          cursor: selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3 ? 'not-allowed' : 'pointer',
                          color: 'white',
                          opacity: selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3 ? 0.5 : 1
                        }}
                        onClick={() => {
                          if (!(selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3)) {
                            addNewAdditionCharges(true); // Pass `false` for Add
                          }
                        }} // Pass `false` for Deduct
                        isDisabled={selectedRow?.isHaveCreditInvoice || selectedRow?.invoicePurposeType === 3}
                      >
                        <RemoveIcon style={{ padding: '0px' }} /> Deduct
                      </Button>
                    </Box>
                    {userPdf && userPdf.length > 0 && (
                      <Box sx={{ height: 'fit-content' }} id="salary-modal">
                        <div>
                          <div
                            className="table-scroll"
                            style={{
                              maxHeight: '160px',
                              overflow: 'auto',
                              margin: '15px 10px 10px 10px',
                            }}
                          >
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                              Invoice PDF
                            </Typography>
                            <Table className="salary-details">
                              <ListHead
                                headLabel={INVOICE_PDF_TABLE_HEAD}
                                onRequestSort={handleRequestSort}
                                onSelectAllClick={handleSelectAllClick}
                                hideCheckboxColumnHeader={hideCheckboxColumn}
                              />              
                              <TableBody>
                                {userPdf
                                  ?.filter((row) =>
                                    selectedRow?.userId
                                      ? row?.userId === selectedRow?.userId
                                      : row?.createdBy === selectedRow?.createdBy 
                                  )
                                  ?.map((row, i) => {
                                    const { fileName, fileContent, fortnoxFileId, isFileAttached, createdDate } = row;
                                    return (
                                      <TableRow hover key={i} tabIndex={-1}>
                                        <TableCell align="left" style={{ padding: '6px 16px' }}>
                                          {fileName}
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: '6px 16px' }}>
                                          {isFileAttached ? 'Yes' : 'No'}
                                        </TableCell>
                                        <TableCell align="left" style={{ padding: '6px 16px' }}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() =>
                                              handleDownloadSinglePdf(fileName, fileContent, fortnoxFileId, createdDate)
                                            }
                                          >
                                            Download
                                          </Button>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                              </TableBody>
                            </Table>
                          </div>
                        </div>
                      </Box>
                    )}
                    <div
                      style={{
                        margin: '25px 0 0',
                        float: 'right',
                        gap: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      
                      <BookEditInvoice
                        selectedRow={selectedRow}
                        selectedRowInvoiceNumber={selectedRowInvoiceNumber}
                        onBookingSuccess={async () => {
                          await fetchInvoices();
                          handleCloseModal();
                        }}
                        onClose={handleCloseModal}
                        selectedTabValue={selectedTabValue}
                      />
                     
                          <Button
                          variant="outlined"
                          onClick={() => {
                            handleOpenSendEmailModal();
                          }}
                        >
                          Send Invoice Email
                        </Button>

                      <Tooltip 
                        title={(selectedRow?.isUserUploadedToComplyCube === null) ? '' : 'Already synced to ComplyCube'}
                        arrow
                      >
                        <span>
                          <Button
                            variant={selectedRow?.isUserUploadedToComplyCube === true ? "contained" : "outlined"}
                            onClick={() => {
                              handleComplyCube(selectedRow?.userId? selectedRow?.userId : selectedRow?.createdBy);
                            }}
                            disabled={selectedRow?.isUserUploadedToComplyCube === true}
                            style={{
                              backgroundColor: selectedRow?.isUserUploadedToComplyCube === true ? '#4caf50' : 'transparent',
                              color: selectedRow?.isUserUploadedToComplyCube === true ? 'white' : '',
                              cursor: selectedRow?.isUserUploadedToComplyCube === true ? 'not-allowed' : 'pointer'
                            }}
                          >
                            Complycube
                          </Button>
                        </span>
                      </Tooltip>
                                     
                      {selectedRow && (
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Button
                          variant="outlined"
                          onClick={() => {
                            handleViewPdf(selectedRowInvoiceNumber, pdfLang)}}
                        >
                          Download PDF
                        </Button>
                        <Select
                          value={pdfLang}
                          onChange={e => setPdfLang(e.target.value)}
                          size="small"
                          sx={{ minWidth: 80, fontSize: '0.9rem' }}
                        >
                          <MenuItem value="en-us">English</MenuItem>
                          <MenuItem value="sv-se">Swedish</MenuItem>
                        </Select>
                      </Stack>
                      )}
                      <PictureAsPdfIcon
                        onClick={() => {
                          downloadSalaryDetailsAsPdf(selectedRow?.invoiceNumber);
                        }}
                        sx={{
                          ml: 1,
                          background: '#62b5e5',
                          color: '#fff',
                          mt: 7,
                          cursor: 'pointer',
                          marginTop: '0',
                        }}
                      />
                      <Button
                        onClick={handleCloseModal}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Close
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={isEditModalOpen}
                  onClose={handleCloseEditModal}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()} style={{ padding: "16px 16px" }}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      {editCreditModalDetails?.isAnyResponseOnEditCreditInvoice
                        ? `Changes have already been ${editCreditModalDetails.isRequestApproved === true ? "approved" : "rejected"}`
                        : editCreditModalDetails?.invoiceEditItems?.length === 0
                          ? 'No invoice edit requests found.'
                          : ' '}{' '}
                    </Typography>
                    <div
                      style={{
                        margin: '16px 0 0',
                        float: 'right',
                        gap: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        onClick={handleCloseEditModal}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Close
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={activateModal.show}
                  onClose={() => setActivateModal({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Are you sure you want to deactivate this invoice?
                    </Typography>
                    <div
                      style={{
                        margin: '25px 0 0',
                        float: 'right',
                        gap: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        onClick={() => setActivateModal({ show: false })}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        onClick={() => activateOrDeactivate(activateModal.invoiceNumber, 'false')}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={createAccountModal.show}
                  onClose={() => setCreateAccountModal({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      {(createAccountModal.type === 'create' && 'Are you sure you want to create salary?') ||
                        (createAccountModal.type === 'cancel' && 'Are you sure you want to cancel?') ||
                        (createAccountModal.type === 'reminder' &&
                          (new Date(createAccountModal.dueDate) > new Date()
                            ? "Even though your due date hasn't arrived yet, do you still want to send a reminder invoice?"
                            : 'Are you sure you want to send reminder invoice to customer?')) ||
                        'Are you sure you want to delete salary?'}
                    </Typography>
                    <div
                      style={{ margin: '10px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <Button
                        onClick={() => setCreateAccountModal({ show: false })}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        onClick={() => {
                          if (createAccountModal.type === 'create') {
                            createSalary(createAccountModal.invoiceNumber);
                          } else if (createAccountModal.type === 'cancel') {
                            cancelInvoice(createAccountModal.invoiceNumber);
                          } else if (createAccountModal.type === 'reminder') {
                            adminInvoiceReminder(createAccountModal.invoiceNumber);
                          } else {
                            handleUndoCreate(createAccountModal.invoiceNumber);
                          }

                          setCreateAccountModal({ ...createAccountModal, show: false });
                        }}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={expressPaymenttModal.show}
                  onClose={() => setExpressPaymentModal({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      {expressPaymenttModal.type
                        ? `Are you sure you want to pay express payment for user #${expressPaymenttModal.id} ?`
                        : `Are you sure you want to cancel express payment for user #${expressPaymenttModal.id} ?`}
                    </Typography>
                    <div
                      style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <Button
                        onClick={handleCancelExpressPayment}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                        onClick={handleCreateExpressPayment}
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={IstogglePaidUnpaid.show}
                  onClose={() => setCreateAccountModal({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      {IstogglePaidUnpaid.type === 'paid' && 'Are you sure you want to paid invoice?'}
                      {IstogglePaidUnpaid.type === 'unpaid' && 'Are you sure you want to unpaid invoice?'}
                    </Typography>
                    <div
                      style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <Button
                        onClick={() => setIstogglePaidUnpaid({ show: false })}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        onClick={() => {
                          if (IstogglePaidUnpaid.type === 'paid' || IstogglePaidUnpaid.type === 'unpaid') {
                            handlePaidSalary(IstogglePaidUnpaid);
                          }
                          setIstogglePaidUnpaid({ ...IstogglePaidUnpaid, show: false });
                        }}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={isChangeStatus.show}
                  onClose={() => setCreateAccountModal({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      {isChangeStatus.type === 'Unpaid' && 'Are you sure you want to mark this as unpaid? This will only update the salary status.'}
                      {isChangeStatus.type === 'paid' && 'Are you sure you want to mark this salary as paid? This will not create salary. If you want to create salary, click on create salary.'}
                    </Typography>
                    <div
                      style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <Button
                        onClick={() => setisChangeStatus({ show: false })}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        onClick={() => {
                          if (isChangeStatus.type === 'paid') {
                            handleChangeSalaryStatus(isChangeStatus);
                          } else if (isChangeStatus.type === 'Unpaid') {
                            handleChangeSalaryStatusUnpaid(isChangeStatus);
                          }
                          setisChangeStatus({ ...isChangeStatus, show: false });
                        }}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                {/* Add Notes  Modal */}
                <Modal
                  open={toggleNote}
                  onClose={() => {
                    setToggleNote(false);
                    setNotesContent('');
                    setIsNotesContentEmpty(false);
                    setSelectedNotes([]);
                  }}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={commentStyle}>
                    <Box sx={{ height: 'fit-content' }} id="usersList-modal">
                      <IconButton
                        color="inherit"
                        onClick={() => {
                          setToggleNote(false);
                          setNotesContent('');
                          setIsNotesContentEmpty(false);
                          setSelectedNotes([]);
                        }}
                        sx={{
                          position: 'absolute',
                          right: 5,
                          top: 0,
                        }}
                        aria-label="close"
                      >
                        <ClearIcon style={{ fontSize: 26 }} />
                      </IconButton>
                      <Typography id="modal-modal-title" variant="h6" component="h2" style={{ width: '95%' }}>
                        Notes
                      </Typography>
                      <Form>
                        <Form.Group
                          className="modalform"
                          style={{ marginTop: '20px', display: 'flex', alignItems: 'center' }}
                        >
                          <Form.Control
                            as="textarea"
                            rows={3}
                            style={{
                              resize: 'none',
                              width: '50%',
                              borderRadius: '12px',
                              borderColor: isNotesContentEmpty && '#eb5e5e',
                            }}
                            onChange={(e) => setNotesContent(e.target.value)}
                            value={notesContent}
                          />
                          <Button
                            variant="contained"
                            style={{ height: '40px', marginLeft: '20px' }}
                            onClick={postAddnotes}
                          >
                            <AddCircleIcon />
                          </Button>
                          <Button
                            variant="contained"
                            color="error"
                            style={{ height: '40px', marginLeft: '10px' }}
                            onClick={() => {
                              if (selectedNotes.length > 0) {
                                setDeleteNotesModal({ show: true });
                              }
                            }}
                            disabled={selectedNotes.length === 0}
                          >
                            <DeleteIcon />
                          </Button>

                        </Form.Group>
                      </Form>
                      <div style={{ height: '250px', overflow: 'auto', marginTop: '10px' }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell padding="checkbox">
                                <Checkbox
                                  indeterminate={selectedNotes.length > 0 && selectedNotes.length < commentList.length}
                                  checked={commentList.length > 0 && selectedNotes.length === commentList.length}
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setSelectedNotes(commentList.map((_, index) => index));
                                    } else {
                                      setSelectedNotes([]);
                                    }
                                  }}
                                />
                              </TableCell>
                              <TableCell>Date </TableCell>
                              <TableCell>Message</TableCell>
                              <TableCell>Added By</TableCell>
                            </TableRow>
                          </TableHead>
                          {loading ? (
                            ''
                          ) : (
                            <TableBody>
                              {commentList?.length > 0 ? (
                                commentList?.map((row, index) => (
                                  <TableRow key={index}>
                                    <TableCell padding="checkbox">
                                      <Checkbox
                                        checked={selectedNotes.includes(index)}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setSelectedNotes([...selectedNotes, index]);
                                          } else {
                                            setSelectedNotes(selectedNotes.filter(i => i !== index));
                                          }
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell> {formatDate(row?.createdDate)}</TableCell>
                                    <TableCell>
                                      {row?.description?.length > 30 ? (
                                        <TooltipWithCopy text={row?.description} />
                                      ) : (
                                        row?.description
                                      )}
                                    </TableCell>
                                    <TableCell> {row?.addedBy} </TableCell>
                                  </TableRow>
                                ))
                              ) : (
                                <TableRow className="text-center">
                                  <TableCell colSpan={4} style={{ textAlign: 'center' }}>
                                    No record found
                                  </TableCell>
                                </TableRow>
                              )}
                            </TableBody>
                          )}
                        </Table>
                      </div>
                    </Box>
                  </Box>
                </Modal>

                {/* Delete Notes Confirmation Modal */}
                <Modal
                  open={deleteNotesModal.show}
                  onClose={() => setDeleteNotesModal({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Are you sure you want to delete {selectedNotes.length > 1 ? 'these notes' : 'this note'}?
                    </Typography>
                    <div
                      style={{
                        margin: '25px 0 0',
                        float: 'right',
                        gap: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        onClick={() => setDeleteNotesModal({ show: false })}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        onClick={handleDeleteNotes}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                {/* Activate Invoice */}

                <Modal
                  open={toggleIsActive.show}
                  onClose={() => settoggleIsActive({ show: false })}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Are you sure you want to activate this invoice?
                    </Typography>
                    <div
                      style={{
                        margin: '25px 0 0',
                        float: 'right',
                        gap: '10px',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        onClick={() => settoggleIsActive({ show: false })}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>
                      <Button
                        onClick={() => handleActivateInvoice(toggleIsActive.invoiceNumber, 'true')}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        Yes
                      </Button>
                    </div>
                  </Box>
                </Modal>

                <Modal
                  open={showSyncModal}
                  onClose={(prevState) => {
                    setshowSyncModal(false);
                  }}
                  aria-labelledby="alert-dialog-title"
                  aria-describedby="alert-dialog-description"
                >
                  <Box sx={getModalBoxStyle()}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                      Are you sure you want to sync?
                    </Typography>

                    <div
                      style={{ margin: '25px 0 0', float: 'right', gap: '10px', display: 'flex', alignItems: 'center' }}
                    >
                      <Button
                        onClick={(prevState) => {
                          setshowSyncModal(false);
                        }}
                        sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                        autoFocus
                      >
                        No
                      </Button>

                      {!isError && (
                        <Button
                          onClick={handleSyncProceed}
                          sx={{ float: 'right', backgroundColor: '#62b5e514' }}
                          autoFocus
                        >
                          Yes
                        </Button>
                      )}
                    </div>
                  </Box>
                </Modal>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={12} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={searchQuery} isLoading={loading} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
          <TablePagination
            rowsPerPageOptions={[50, 100, 250, 500]}
            component="div"
            count={totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      ) : selectedTabValue === '7' ? (
        <ReminderInvoiceDataTable hideCheckboxColumnHeader={hideCheckboxColumn}
          userId={userIdFromParams} />
      ) : (
        ''
      )}
    </>
  );
  return (
    <>
      <Page title="Invoices">
        {loading && <Loader />}
        <Container>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
            <Stack direction="row" alignItems="center">
              {userIdFromParams && (
                <IconButton onClick={() => navigate(-1)}>
                  <Iconify icon="eva:arrow-back-fill" width={24} height={24} />
                </IconButton>
              )}
              <Typography variant="h4" sx={{ ml: 1 }}>
                {userIdFromParams ? 'User Invoices' : 'Invoices'}
              </Typography>
            </Stack>

            <Stack direction="row" justifyContent="space-between">
              {!userIdFromParams && (
                <Tooltip arrow title="Sync To Fortnox">
                  <Button
                    style={{ marginLeft: '10px' }}
                    variant="contained"
                    onClick={() => setshowSyncModal(true)}
                  >
                    Sync To Fortnox
                  </Button>
                </Tooltip>
              )}
            </Stack>
          </Stack>

          <ErrosAlert
            isError={isError}
            messages={messages}
            setshowSyncModal={setshowSyncModal}
            setisError={setisError}
            setMessages={setMessages}
            handleButtonClick={handleButtonClick}
          />

          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isSnackBarOpen}
            autoHideDuration={autoHideDuration}
            onClose={handleSnackBarClose}
          >
            <Alert onClose={handleSnackBarClose} severity={alertStatus} sx={{ width: '100%' }}>
              {alertMessage}
            </Alert>
          </Snackbar>
          <Card>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={selectedTabValue}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={(e, newValue) => handleTabChange(e, newValue)} aria-label="lab API tabs example">
                    <Tab label="UNPAID" value="1" />
                    <Tab label="UNSENT INVOICE" value="10" />   
                    <Tab label="BOOKED" value="9" />
                    <Tab label="PAID" value="2" />
                    <Tab label="COMPLETED" value="3" />
                    <Tab label="INACTIVE" value="5" />
                    <Tab label="CREDIT INVOICE" value="6" />
                    <Tab label="REMINDER" value="7" />   
                    <Tab label="ALL" value="8" />

                    {' '}
                  </TabList>
                </Box>
                <TabPanel value="1">{renderInvoices()}</TabPanel>
                <TabPanel value="9">{renderInvoices()}</TabPanel>
                <TabPanel value="2">{renderInvoices()}</TabPanel>
                <TabPanel value="3">{renderInvoices()}</TabPanel>
                <TabPanel value="5">{renderInvoices()}</TabPanel>
                <TabPanel value="6">{renderInvoices()}</TabPanel>
                <TabPanel value="7">{renderInvoices()}</TabPanel>
                <TabPanel value="8">{renderInvoices()}</TabPanel>
                <TabPanel value="10">{renderInvoices()}</TabPanel>
              </TabContext>
            </Box>
          </Card>
        </Container>
      </Page>

      {/* Send Email Modal */}
      <SendInvoiceEmail
        open={sendEmailModal.open}
        onClose={handleCloseSendEmailModal}
        selectedRow={sendEmailModal.selectedRow}
        invoiceNumber={sendEmailModal.invoiceNumber}
        fetchInvoices={fetchInvoices}
      />

      {/* Credit Details Modal */}
     <Modal
    open={isCreditDetailsModalOpen}
    onClose={handleCloseCreditDetailsModal}
    aria-labelledby="credit-details-modal-title"
    aria-describedby="credit-details-modal-description"
  >
    <Box
      sx={{
        ...getModalBoxStyle(),
        minWidth: 350,
        maxWidth: 400,
        p: 3,
        borderRadius: 2,
        boxShadow: 6,
        bgcolor: '#f7faff',
        border: '1px solid #e3e8ee',
        height: 'auto',
      }}
    >
      <Typography
        id="credit-details-modal-title"
        variant="h6"
        component="h2"
        sx={{
          mb: 2,
          fontWeight: 700,
          color: '#1976d2',
          textAlign: 'center',
          letterSpacing: 1,
        }}
      >
        Credit Details
      </Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 80 }}>
          <Typography sx={{ color: '#90caf9' }}>Loading...</Typography>
        </Box>
      ) : creditDetails ? (
        <>
          <Box
            sx={{
              mb: 2,
              p: 2,
              bgcolor: '#e3f2fd',
              borderRadius: 1,
              boxShadow: 1,
            }}
          >
            <Typography variant="subtitle2" sx={{ color: '#1565c0', fontWeight: 600 }}>
              User Comment
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#263238',
                mt: 0.5,
                fontStyle: creditDetails.userComment ? 'normal' : 'italic',
                opacity: creditDetails.userComment ? 1 : 0.7,
              }}
            >
              {creditDetails.userComment || 'N/A'}
            </Typography>
          </Box>
          <Box
            sx={{
              mb: 2,
              p: 2,
              bgcolor: '#fffde7',
              borderRadius: 1,
              boxShadow: 1,
            }}
          >
            <Typography variant="subtitle2" sx={{ color: '#fbc02d', fontWeight: 600 }}>
              Admin Comment
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#263238',
                mt: 0.5,
                fontStyle: creditDetails.adminComment ? 'normal' : 'italic',
                opacity: creditDetails.adminComment ? 1 : 0.7,
              }}
            >
              {creditDetails.adminComment || 'N/A'}
            </Typography>
          </Box>
        </>
      ) : (
        <Typography sx={{ color: '#bdbdbd', textAlign: 'center', mt: 2 }}>
          No credit details found.
        </Typography>
      )}
      <Box sx={{ mt: 3, textAlign: 'right' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleCloseCreditDetailsModal}
          sx={{
            borderRadius: 2,
            px: 3,
            py: 1,
            fontWeight: 600,
            boxShadow: 2,
            bgcolor: '#1976d2',
            '&:hover': { bgcolor: '#1565c0' },
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  </Modal>
    </>
  );
}
